// 新工具的翻譯定義
// 這個檔案需要合併到 messages.ts 中

export const newToolsTranslations = {
  // 正規表達式測試器
  "regexTester": {
    "title": {
      "zh-TW": "正規表達式測試器",
      "zh-CN": "正则表达式测试器",
      "en": "Regex Tester",
      "hi": "रेगेक्स टेस्टर",
      "ja": "正規表現テスター",
      "ko": "정규표현식 테스터"
    },
    "description": {
      "zh-TW": "即時測試和驗證正規表達式，支援多種模式和高亮顯示匹配結果",
      "zh-CN": "即时测试和验证正则表达式，支持多种模式和高亮显示匹配结果",
      "en": "Test and validate regular expressions in real-time with pattern matching and highlighting",
      "hi": "पैटर्न मिलान और हाइलाइटिंग के साथ वास्तविक समय में रेगुलर एक्सप्रेशन का परीक्षण करें",
      "ja": "パターンマッチングとハイライト機能を使用してリアルタイムで正規表現をテスト",
      "ko": "패턴 매칭 및 하이라이팅으로 실시간 정규표현식 테스트"
    },
    "pattern": {
      "zh-TW": "正規表達式",
      "zh-CN": "正则表达式",
      "en": "Regular Expression",
      "hi": "रेगुलर एक्सप्रेशन",
      "ja": "正規表現",
      "ko": "정규표현식"
    },
    "patternPlaceholder": {
      "zh-TW": "輸入正規表達式...",
      "zh-CN": "输入正则表达式...",
      "en": "Enter regex pattern...",
      "hi": "रेगेक्स पैटर्न दर्ज करें...",
      "ja": "正規表現パターンを入力...",
      "ko": "정규표현식 패턴 입력..."
    },
    "testString": {
      "zh-TW": "測試字串",
      "zh-CN": "测试字符串",
      "en": "Test String",
      "hi": "टेस्ट स्ट्रिंग",
      "ja": "テスト文字列",
      "ko": "테스트 문자열"
    },
    "testStringPlaceholder": {
      "zh-TW": "輸入要測試的文字...",
      "zh-CN": "输入要测试的文字...",
      "en": "Enter text to test...",
      "hi": "परीक्षण के लिए टेक्स्ट दर्ज करें...",
      "ja": "テストするテキストを入力...",
      "ko": "테스트할 텍스트 입력..."
    },
    "highlightedResult": {
      "zh-TW": "高亮結果",
      "zh-CN": "高亮结果",
      "en": "Highlighted Result",
      "hi": "हाइलाइटेड परिणाम",
      "ja": "ハイライト結果",
      "ko": "하이라이트 결과"
    },
    "matches": {
      "zh-TW": "匹配結果",
      "zh-CN": "匹配结果",
      "en": "Matches",
      "hi": "मैच",
      "ja": "マッチ",
      "ko": "매치"
    },
    "match": {
      "zh-TW": "匹配",
      "zh-CN": "匹配",
      "en": "Match",
      "hi": "मैच",
      "ja": "マッチ",
      "ko": "매치"
    },
    "index": {
      "zh-TW": "位置",
      "zh-CN": "位置",
      "en": "Index",
      "hi": "इंडेक्स",
      "ja": "位置",
      "ko": "위치"
    },
    "captureGroups": {
      "zh-TW": "捕獲組",
      "zh-CN": "捕获组",
      "en": "Capture Groups",
      "hi": "कैप्चर ग्रुप",
      "ja": "キャプチャグループ",
      "ko": "캡처 그룹"
    },
    "noMatches": {
      "zh-TW": "沒有找到匹配",
      "zh-CN": "没有找到匹配",
      "en": "No matches found",
      "hi": "कोई मैच नहीं मिला",
      "ja": "マッチが見つかりません",
      "ko": "일치하는 항목 없음"
    },
    "commonPatterns": {
      "zh-TW": "常用正規表達式",
      "zh-CN": "常用正则表达式",
      "en": "Common Patterns",
      "hi": "सामान्य पैटर्न",
      "ja": "よく使うパターン",
      "ko": "자주 사용하는 패턴"
    },
    "presetEmail": {
      "zh-TW": "電子郵件",
      "zh-CN": "电子邮件",
      "en": "Email",
      "hi": "ईमेल",
      "ja": "メールアドレス",
      "ko": "이메일"
    },
    "presetUrl": {
      "zh-TW": "網址 URL",
      "zh-CN": "网址 URL",
      "en": "URL",
      "hi": "URL",
      "ja": "URL",
      "ko": "URL"
    },
    "presetPhone": {
      "zh-TW": "電話號碼",
      "zh-CN": "电话号码",
      "en": "Phone Number",
      "hi": "फोन नंबर",
      "ja": "電話番号",
      "ko": "전화번호"
    },
    "presetIpv4": {
      "zh-TW": "IPv4 地址",
      "zh-CN": "IPv4 地址",
      "en": "IPv4 Address",
      "hi": "IPv4 पता",
      "ja": "IPv4アドレス",
      "ko": "IPv4 주소"
    },
    "presetDate": {
      "zh-TW": "日期格式",
      "zh-CN": "日期格式",
      "en": "Date Format",
      "hi": "दिनांक प्रारूप",
      "ja": "日付形式",
      "ko": "날짜 형식"
    },
    "presetHexColor": {
      "zh-TW": "十六進位顏色",
      "zh-CN": "十六进制颜色",
      "en": "Hex Color",
      "hi": "हेक्स रंग",
      "ja": "16進数カラー",
      "ko": "16진수 색상"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "即時匹配",
      "zh-CN": "即时匹配",
      "en": "Real-time Matching",
      "hi": "रीयल-टाइम मिलान",
      "ja": "リアルタイムマッチング",
      "ko": "실시간 매칭"
    },
    "feature1Description": {
      "zh-TW": "輸入時即時顯示匹配結果",
      "zh-CN": "输入时即时显示匹配结果",
      "en": "See matches as you type",
      "hi": "टाइप करते समय मैच देखें",
      "ja": "入力しながらマッチを確認",
      "ko": "입력하면서 매칭 결과 확인"
    },
    "feature2Title": {
      "zh-TW": "捕獲組支援",
      "zh-CN": "捕获组支持",
      "en": "Capture Groups",
      "hi": "कैप्चर ग्रुप",
      "ja": "キャプチャグループ",
      "ko": "캡처 그룹"
    },
    "feature2Description": {
      "zh-TW": "顯示所有捕獲組的內容",
      "zh-CN": "显示所有捕获组的内容",
      "en": "View all capture group contents",
      "hi": "सभी कैप्चर ग्रुप सामग्री देखें",
      "ja": "すべてのキャプチャグループを表示",
      "ko": "모든 캡처 그룹 내용 보기"
    },
    "feature3Title": {
      "zh-TW": "高亮顯示",
      "zh-CN": "高亮显示",
      "en": "Highlighting",
      "hi": "हाइलाइटिंग",
      "ja": "ハイライト",
      "ko": "하이라이팅"
    },
    "feature3Description": {
      "zh-TW": "在原文中高亮顯示匹配部分",
      "zh-CN": "在原文中高亮显示匹配部分",
      "en": "Highlight matches in original text",
      "hi": "मूल टेक्स्ट में मैच हाइलाइट करें",
      "ja": "元のテキストでマッチをハイライト",
      "ko": "원본 텍스트에서 매치 하이라이트"
    },
    "feature4Title": {
      "zh-TW": "常用模式庫",
      "zh-CN": "常用模式库",
      "en": "Pattern Library",
      "hi": "पैटर्न लाइब्रेरी",
      "ja": "パターンライブラリ",
      "ko": "패턴 라이브러리"
    },
    "feature4Description": {
      "zh-TW": "內建常用正規表達式",
      "zh-CN": "内置常用正则表达式",
      "en": "Built-in common regex patterns",
      "hi": "बिल्ट-इन सामान्य रेगेक्स पैटर्न",
      "ja": "組み込みの一般的な正規表現",
      "ko": "내장된 일반 정규표현식 패턴"
    }
  },

  // 時間戳轉換器
  "timestampConverter": {
    "title": {
      "zh-TW": "時間戳轉換器",
      "zh-CN": "时间戳转换器",
      "en": "Timestamp Converter",
      "hi": "टाइमस्टैम्प कनवर्टर",
      "ja": "タイムスタンプ変換",
      "ko": "타임스탬프 변환기"
    },
    "description": {
      "zh-TW": "在 Unix 時間戳、ISO 8601 和各種日期格式之間轉換",
      "zh-CN": "在 Unix 时间戳、ISO 8601 和各种日期格式之间转换",
      "en": "Convert between Unix timestamp, ISO 8601, and various date formats",
      "hi": "Unix टाइमस्टैम्प, ISO 8601 और विभिन्न दिनांक प्रारूपों के बीच रूपांतरण करें",
      "ja": "Unixタイムスタンプ、ISO 8601、各種日付形式を変換",
      "ko": "Unix 타임스탬프, ISO 8601 및 다양한 날짜 형식 간 변환"
    },
    "currentTime": {
      "zh-TW": "當前時間戳",
      "zh-CN": "当前时间戳",
      "en": "Current Timestamp",
      "hi": "वर्तमान टाइमस्टैम्प",
      "ja": "現在のタイムスタンプ",
      "ko": "현재 타임스탬프"
    },
    "timestampToDate": {
      "zh-TW": "時間戳轉日期",
      "zh-CN": "时间戳转日期",
      "en": "Timestamp to Date",
      "hi": "टाइमस्टैम्प से दिनांक",
      "ja": "タイムスタンプから日付",
      "ko": "타임스탬프를 날짜로"
    },
    "dateToTimestamp": {
      "zh-TW": "日期轉時間戳",
      "zh-CN": "日期转时间戳",
      "en": "Date to Timestamp",
      "hi": "दिनांक से टाइमस्टैम्प",
      "ja": "日付からタイムスタンプ",
      "ko": "날짜를 타임스탬프로"
    },
    "inputTimestamp": {
      "zh-TW": "輸入時間戳",
      "zh-CN": "输入时间戳",
      "en": "Enter Timestamp",
      "hi": "टाइमस्टैम्प दर्ज करें",
      "ja": "タイムスタンプを入力",
      "ko": "타임스탬프 입력"
    },
    "timestampPlaceholder": {
      "zh-TW": "例如：1704067200",
      "zh-CN": "例如：1704067200",
      "en": "e.g., 1704067200",
      "hi": "जैसे: 1704067200",
      "ja": "例: 1704067200",
      "ko": "예: 1704067200"
    },
    "unit": {
      "zh-TW": "單位",
      "zh-CN": "单位",
      "en": "Unit",
      "hi": "इकाई",
      "ja": "単位",
      "ko": "단위"
    },
    "seconds": {
      "zh-TW": "秒",
      "zh-CN": "秒",
      "en": "Seconds",
      "hi": "सेकंड",
      "ja": "秒",
      "ko": "초"
    },
    "milliseconds": {
      "zh-TW": "毫秒",
      "zh-CN": "毫秒",
      "en": "Milliseconds",
      "hi": "मिलीसेकंड",
      "ja": "ミリ秒",
      "ko": "밀리초"
    },
    "localTime": {
      "zh-TW": "本地時間",
      "zh-CN": "本地时间",
      "en": "Local Time",
      "hi": "स्थानीय समय",
      "ja": "ローカル時間",
      "ko": "로컬 시간"
    },
    "relative": {
      "zh-TW": "相對時間",
      "zh-CN": "相对时间",
      "en": "Relative",
      "hi": "सापेक्ष",
      "ja": "相対時間",
      "ko": "상대 시간"
    },
    "inputDate": {
      "zh-TW": "選擇日期時間",
      "zh-CN": "选择日期时间",
      "en": "Select Date & Time",
      "hi": "दिनांक और समय चुनें",
      "ja": "日時を選択",
      "ko": "날짜 및 시간 선택"
    },
    "timezone": {
      "zh-TW": "時區",
      "zh-CN": "时区",
      "en": "Timezone",
      "hi": "समय क्षेत्र",
      "ja": "タイムゾーン",
      "ko": "시간대"
    },
    "localTimezone": {
      "zh-TW": "本地時區",
      "zh-CN": "本地时区",
      "en": "Local Timezone",
      "hi": "स्थानीय समय क्षेत्र",
      "ja": "ローカルタイムゾーン",
      "ko": "로컬 시간대"
    },
    "now": {
      "zh-TW": "現在",
      "zh-CN": "现在",
      "en": "Now",
      "hi": "अभी",
      "ja": "現在",
      "ko": "현재"
    },
    "invalidTimestamp": {
      "zh-TW": "無效的時間戳",
      "zh-CN": "无效的时间戳",
      "en": "Invalid timestamp",
      "hi": "अमान्य टाइमस्टैम्प",
      "ja": "無効なタイムスタンプ",
      "ko": "잘못된 타임스탬프"
    },
    "invalidDate": {
      "zh-TW": "無效的日期",
      "zh-CN": "无效的日期",
      "en": "Invalid date",
      "hi": "अमान्य दिनांक",
      "ja": "無効な日付",
      "ko": "잘못된 날짜"
    },
    "timezoneConverter": {
      "zh-TW": "時區轉換",
      "zh-CN": "时区转换",
      "en": "Timezone Converter",
      "hi": "समय क्षेत्र कनवर्टर",
      "ja": "タイムゾーン変換",
      "ko": "시간대 변환"
    },
    "sourceTime": {
      "zh-TW": "來源時間",
      "zh-CN": "来源时间",
      "en": "Source Time",
      "hi": "स्रोत समय",
      "ja": "元の時間",
      "ko": "원본 시간"
    },
    "fromTimezone": {
      "zh-TW": "來源時區",
      "zh-CN": "来源时区",
      "en": "From Timezone",
      "hi": "स्रोत समय क्षेत्र",
      "ja": "元のタイムゾーン",
      "ko": "원본 시간대"
    },
    "toTimezone": {
      "zh-TW": "目標時區",
      "zh-CN": "目标时区",
      "en": "To Timezone",
      "hi": "लक्ष्य समय क्षेत्र",
      "ja": "変換先タイムゾーン",
      "ko": "대상 시간대"
    },
    "fromNow": {
      "zh-TW": "後",
      "zh-CN": "后",
      "en": "from now",
      "hi": "से अब",
      "ja": "後",
      "ko": "후"
    },
    "ago": {
      "zh-TW": "前",
      "zh-CN": "前",
      "en": "ago",
      "hi": "पहले",
      "ja": "前",
      "ko": "전"
    },
    "years": {
      "zh-TW": "年",
      "zh-CN": "年",
      "en": "years",
      "hi": "वर्ष",
      "ja": "年",
      "ko": "년"
    },
    "months": {
      "zh-TW": "月",
      "zh-CN": "月",
      "en": "months",
      "hi": "महीने",
      "ja": "ヶ月",
      "ko": "개월"
    },
    "days": {
      "zh-TW": "天",
      "zh-CN": "天",
      "en": "days",
      "hi": "दिन",
      "ja": "日",
      "ko": "일"
    },
    "hours": {
      "zh-TW": "小時",
      "zh-CN": "小时",
      "en": "hours",
      "hi": "घंटे",
      "ja": "時間",
      "ko": "시간"
    },
    "minutes": {
      "zh-TW": "分鐘",
      "zh-CN": "分钟",
      "en": "minutes",
      "hi": "मिनट",
      "ja": "分",
      "ko": "분"
    },
    "secondsAgo": {
      "zh-TW": "秒",
      "zh-CN": "秒",
      "en": "seconds",
      "hi": "सेकंड",
      "ja": "秒",
      "ko": "초"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "雙向轉換",
      "zh-CN": "双向转换",
      "en": "Two-way Conversion",
      "hi": "दो-तरफा रूपांतरण",
      "ja": "双方向変換",
      "ko": "양방향 변환"
    },
    "feature1Description": {
      "zh-TW": "支援時間戳和日期的雙向轉換",
      "zh-CN": "支持时间戳和日期的双向转换",
      "en": "Convert between timestamp and date in both directions",
      "hi": "दोनों दिशाओं में टाइमस्टैम्प और दिनांक के बीच रूपांतरण करें",
      "ja": "タイムスタンプと日付の双方向変換",
      "ko": "타임스탬프와 날짜 간 양방향 변환"
    },
    "feature2Title": {
      "zh-TW": "多時區支援",
      "zh-CN": "多时区支持",
      "en": "Multi-timezone Support",
      "hi": "बहु-समय क्षेत्र समर्थन",
      "ja": "複数タイムゾーン対応",
      "ko": "다중 시간대 지원"
    },
    "feature2Description": {
      "zh-TW": "在不同時區之間輕鬆轉換",
      "zh-CN": "在不同时区之间轻松转换",
      "en": "Easily convert between different timezones",
      "hi": "विभिन्न समय क्षेत्रों के बीच आसानी से रूपांतरण करें",
      "ja": "異なるタイムゾーン間で簡単に変換",
      "ko": "다른 시간대 간 쉽게 변환"
    },
    "feature3Title": {
      "zh-TW": "即時更新",
      "zh-CN": "即时更新",
      "en": "Real-time Update",
      "hi": "रीयल-टाइम अपडेट",
      "ja": "リアルタイム更新",
      "ko": "실시간 업데이트"
    },
    "feature3Description": {
      "zh-TW": "當前時間戳即時更新",
      "zh-CN": "当前时间戳即时更新",
      "en": "Current timestamp updates in real-time",
      "hi": "वर्तमान टाइमस्टैम्प रीयल-टाइम में अपडेट होता है",
      "ja": "現在のタイムスタンプをリアルタイムで更新",
      "ko": "현재 타임스탬프 실시간 업데이트"
    },
    "feature4Title": {
      "zh-TW": "相對時間",
      "zh-CN": "相对时间",
      "en": "Relative Time",
      "hi": "सापेक्ष समय",
      "ja": "相対時間",
      "ko": "상대 시간"
    },
    "feature4Description": {
      "zh-TW": "顯示人性化的相對時間描述",
      "zh-CN": "显示人性化的相对时间描述",
      "en": "Display human-readable relative time",
      "hi": "मानव-पठनीय सापेक्ष समय प्रदर्शित करें",
      "ja": "人間が読みやすい相対時間を表示",
      "ko": "읽기 쉬운 상대 시간 표시"
    }
  },

  // HTTP 狀態碼
  "httpStatusCodes": {
    "title": {
      "zh-TW": "HTTP 狀態碼查詢",
      "zh-CN": "HTTP 状态码查询",
      "en": "HTTP Status Codes",
      "hi": "HTTP स्थिति कोड",
      "ja": "HTTPステータスコード",
      "ko": "HTTP 상태 코드"
    },
    "description": {
      "zh-TW": "完整的 HTTP 狀態碼參考，包含詳細說明和使用場景",
      "zh-CN": "完整的 HTTP 状态码参考，包含详细说明和使用场景",
      "en": "Complete HTTP status code reference with detailed descriptions and use cases",
      "hi": "विस्तृत विवरण और उपयोग के मामलों के साथ पूर्ण HTTP स्थिति कोड संदर्भ",
      "ja": "詳細な説明と使用例を含む完全なHTTPステータスコードリファレンス",
      "ko": "상세 설명 및 사용 사례가 포함된 완전한 HTTP 상태 코드 참조"
    },
    "searchPlaceholder": {
      "zh-TW": "搜尋狀態碼或描述...",
      "zh-CN": "搜索状态码或描述...",
      "en": "Search code or description...",
      "hi": "कोड या विवरण खोजें...",
      "ja": "コードまたは説明を検索...",
      "ko": "코드 또는 설명 검색..."
    },
    "informational": {
      "zh-TW": "資訊回應",
      "zh-CN": "信息响应",
      "en": "Informational",
      "hi": "सूचनात्मक",
      "ja": "情報",
      "ko": "정보"
    },
    "informationalDesc": {
      "zh-TW": "請求已接收，繼續處理",
      "zh-CN": "请求已接收，继续处理",
      "en": "Request received, continuing process",
      "hi": "अनुरोध प्राप्त हुआ, प्रक्रिया जारी",
      "ja": "リクエスト受信、処理継続中",
      "ko": "요청 수신됨, 처리 계속"
    },
    "success": {
      "zh-TW": "成功",
      "zh-CN": "成功",
      "en": "Success",
      "hi": "सफलता",
      "ja": "成功",
      "ko": "성공"
    },
    "successDesc": {
      "zh-TW": "請求已成功接收、理解和處理",
      "zh-CN": "请求已成功接收、理解和处理",
      "en": "Request successfully received, understood, and processed",
      "hi": "अनुरोध सफलतापूर्वक प्राप्त, समझा और संसाधित",
      "ja": "リクエストは正常に受信、理解、処理されました",
      "ko": "요청이 성공적으로 수신, 이해 및 처리됨"
    },
    "redirection": {
      "zh-TW": "重新導向",
      "zh-CN": "重定向",
      "en": "Redirection",
      "hi": "पुनर्निर्देशन",
      "ja": "リダイレクト",
      "ko": "리디렉션"
    },
    "redirectionDesc": {
      "zh-TW": "需要進一步操作以完成請求",
      "zh-CN": "需要进一步操作以完成请求",
      "en": "Further action needed to complete request",
      "hi": "अनुरोध पूरा करने के लिए आगे की कार्रवाई आवश्यक",
      "ja": "リクエストを完了するには追加のアクションが必要",
      "ko": "요청 완료를 위해 추가 작업 필요"
    },
    "clientError": {
      "zh-TW": "客戶端錯誤",
      "zh-CN": "客户端错误",
      "en": "Client Error",
      "hi": "क्लाइंट त्रुटि",
      "ja": "クライアントエラー",
      "ko": "클라이언트 오류"
    },
    "clientErrorDesc": {
      "zh-TW": "請求包含錯誤或無法完成",
      "zh-CN": "请求包含错误或无法完成",
      "en": "Request contains errors or cannot be fulfilled",
      "hi": "अनुरोध में त्रुटियां हैं या पूरा नहीं किया जा सकता",
      "ja": "リクエストにエラーがあるか完了できません",
      "ko": "요청에 오류가 있거나 처리할 수 없음"
    },
    "serverError": {
      "zh-TW": "伺服器錯誤",
      "zh-CN": "服务器错误",
      "en": "Server Error",
      "hi": "सर्वर त्रुटि",
      "ja": "サーバーエラー",
      "ko": "서버 오류"
    },
    "serverErrorDesc": {
      "zh-TW": "伺服器無法完成有效請求",
      "zh-CN": "服务器无法完成有效请求",
      "en": "Server failed to fulfill a valid request",
      "hi": "सर्वर वैध अनुरोध पूरा करने में विफल",
      "ja": "サーバーが有効なリクエストを完了できませんでした",
      "ko": "서버가 유효한 요청을 처리하지 못함"
    },
    "example": {
      "zh-TW": "範例",
      "zh-CN": "示例",
      "en": "Example",
      "hi": "उदाहरण",
      "ja": "例",
      "ko": "예시"
    },
    "quickLookup": {
      "zh-TW": "快速查詢",
      "zh-CN": "快速查询",
      "en": "Quick Lookup",
      "hi": "त्वरित खोज",
      "ja": "クイック検索",
      "ko": "빠른 조회"
    },
    "enterCode": {
      "zh-TW": "輸入狀態碼",
      "zh-CN": "输入状态码",
      "en": "Enter status code",
      "hi": "स्थिति कोड दर्ज करें",
      "ja": "ステータスコードを入力",
      "ko": "상태 코드 입력"
    },
    "notFound": {
      "zh-TW": "找不到此狀態碼",
      "zh-CN": "找不到此状态码",
      "en": "Status code not found",
      "hi": "स्थिति कोड नहीं मिला",
      "ja": "ステータスコードが見つかりません",
      "ko": "상태 코드를 찾을 수 없음"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "完整參考",
      "zh-CN": "完整参考",
      "en": "Complete Reference",
      "hi": "पूर्ण संदर्भ",
      "ja": "完全なリファレンス",
      "ko": "완전한 참조"
    },
    "feature1Description": {
      "zh-TW": "涵蓋所有標準 HTTP 狀態碼",
      "zh-CN": "涵盖所有标准 HTTP 状态码",
      "en": "Covers all standard HTTP status codes",
      "hi": "सभी मानक HTTP स्थिति कोड शामिल",
      "ja": "すべての標準HTTPステータスコードを網羅",
      "ko": "모든 표준 HTTP 상태 코드 포함"
    },
    "feature2Title": {
      "zh-TW": "使用場景",
      "zh-CN": "使用场景",
      "en": "Use Cases",
      "hi": "उपयोग के मामले",
      "ja": "使用例",
      "ko": "사용 사례"
    },
    "feature2Description": {
      "zh-TW": "每個狀態碼都附有實際使用範例",
      "zh-CN": "每个状态码都附有实际使用示例",
      "en": "Each code comes with practical examples",
      "hi": "प्रत्येक कोड के साथ व्यावहारिक उदाहरण",
      "ja": "各コードに実用的な例が付属",
      "ko": "각 코드에 실용적인 예시 포함"
    },
    "100": {
      "zh-TW": "伺服器已收到請求標頭，客戶端應繼續發送請求主體",
      "zh-CN": "服务器已收到请求头，客户端应继续发送请求主体",
      "en": "Server has received request headers, client should continue with request body",
      "hi": "सर्वर ने अनुरोध हेडर प्राप्त किए हैं, क्लाइंट को अनुरोध बॉडी के साथ जारी रखना चाहिए",
      "ja": "サーバーはリクエストヘッダーを受信しました。クライアントはリクエストボディを送信してください",
      "ko": "서버가 요청 헤더를 수신했으며 클라이언트는 요청 본문을 계속 전송해야 함"
    },
    "101": {
      "zh-TW": "伺服器正在切換到客戶端請求的協議",
      "zh-CN": "服务器正在切换到客户端请求的协议",
      "en": "Server is switching to the protocol requested by client",
      "hi": "सर्वर क्लाइंट द्वारा अनुरोधित प्रोटोकॉल पर स्विच कर रहा है",
      "ja": "サーバーはクライアントがリクエストしたプロトコルに切り替え中",
      "ko": "서버가 클라이언트가 요청한 프로토콜로 전환 중"
    },
    "102": {
      "zh-TW": "伺服器正在處理請求，但尚未完成",
      "zh-CN": "服务器正在处理请求，但尚未完成",
      "en": "Server is processing the request, not yet complete",
      "hi": "सर्वर अनुरोध संसाधित कर रहा है, अभी पूरा नहीं हुआ",
      "ja": "サーバーはリクエストを処理中ですが、まだ完了していません",
      "ko": "서버가 요청을 처리 중이며 아직 완료되지 않음"
    },
    "103": {
      "zh-TW": "用於預載資源的早期提示",
      "zh-CN": "用于预加载资源的早期提示",
      "en": "Early hints for preloading resources",
      "hi": "संसाधनों को प्रीलोड करने के लिए शुरुआती संकेत",
      "ja": "リソースをプリロードするための早期ヒント",
      "ko": "리소스 프리로딩을 위한 조기 힌트"
    },
    "200": {
      "zh-TW": "請求成功",
      "zh-CN": "请求成功",
      "en": "Request succeeded",
      "hi": "अनुरोध सफल",
      "ja": "リクエスト成功",
      "ko": "요청 성공"
    },
    "201": {
      "zh-TW": "請求成功並已創建新資源",
      "zh-CN": "请求成功并已创建新资源",
      "en": "Request succeeded and a new resource was created",
      "hi": "अनुरोध सफल और नया संसाधन बनाया गया",
      "ja": "リクエスト成功、新しいリソースが作成されました",
      "ko": "요청 성공, 새 리소스가 생성됨"
    },
    "202": {
      "zh-TW": "請求已接受但尚未處理",
      "zh-CN": "请求已接受但尚未处理",
      "en": "Request accepted but not yet processed",
      "hi": "अनुरोध स्वीकार किया गया लेकिन अभी संसाधित नहीं",
      "ja": "リクエストは受け入れられましたが、まだ処理されていません",
      "ko": "요청이 수락되었지만 아직 처리되지 않음"
    },
    "203": {
      "zh-TW": "返回的資訊可能來自代理伺服器",
      "zh-CN": "返回的信息可能来自代理服务器",
      "en": "Returned information may be from a proxy server",
      "hi": "लौटाई गई जानकारी प्रॉक्सी सर्वर से हो सकती है",
      "ja": "返された情報はプロキシサーバーからのものである可能性があります",
      "ko": "반환된 정보가 프록시 서버에서 온 것일 수 있음"
    },
    "204": {
      "zh-TW": "請求成功但沒有內容返回",
      "zh-CN": "请求成功但没有内容返回",
      "en": "Request succeeded but no content to return",
      "hi": "अनुरोध सफल लेकिन लौटाने के लिए कोई सामग्री नहीं",
      "ja": "リクエスト成功、返すコンテンツなし",
      "ko": "요청 성공, 반환할 콘텐츠 없음"
    },
    "205": {
      "zh-TW": "請求成功，客戶端應重置文件視圖",
      "zh-CN": "请求成功，客户端应重置文档视图",
      "en": "Request succeeded, client should reset the document view",
      "hi": "अनुरोध सफल, क्लाइंट को दस्तावेज़ दृश्य रीसेट करना चाहिए",
      "ja": "リクエスト成功、クライアントはドキュメントビューをリセットする必要があります",
      "ko": "요청 성공, 클라이언트가 문서 보기를 재설정해야 함"
    },
    "206": {
      "zh-TW": "部分內容，用於分段下載",
      "zh-CN": "部分内容，用于分段下载",
      "en": "Partial content for range requests",
      "hi": "रेंज अनुरोधों के लिए आंशिक सामग्री",
      "ja": "範囲リクエストの部分コンテンツ",
      "ko": "범위 요청에 대한 부분 콘텐츠"
    },
    "207": {
      "zh-TW": "多個狀態碼可能適用",
      "zh-CN": "多个状态码可能适用",
      "en": "Multiple status codes may apply",
      "hi": "कई स्थिति कोड लागू हो सकते हैं",
      "ja": "複数のステータスコードが適用される可能性があります",
      "ko": "여러 상태 코드가 적용될 수 있음"
    },
    "208": {
      "zh-TW": "已經報告過的成員",
      "zh-CN": "已经报告过的成员",
      "en": "Members already reported",
      "hi": "सदस्य पहले से रिपोर्ट किए गए",
      "ja": "すでに報告されたメンバー",
      "ko": "이미 보고된 멤버"
    },
    "226": {
      "zh-TW": "伺服器已完成 GET 請求",
      "zh-CN": "服务器已完成 GET 请求",
      "en": "Server has fulfilled a GET request",
      "hi": "सर्वर ने GET अनुरोध पूरा किया",
      "ja": "サーバーはGETリクエストを完了しました",
      "ko": "서버가 GET 요청을 완료함"
    },
    "300": {
      "zh-TW": "請求有多個可能的回應",
      "zh-CN": "请求有多个可能的响应",
      "en": "Multiple possible responses available",
      "hi": "कई संभावित प्रतिक्रियाएं उपलब्ध",
      "ja": "複数の可能な応答があります",
      "ko": "여러 가능한 응답 사용 가능"
    },
    "301": {
      "zh-TW": "資源已永久移動到新位置",
      "zh-CN": "资源已永久移动到新位置",
      "en": "Resource has been permanently moved to a new location",
      "hi": "संसाधन स्थायी रूप से नए स्थान पर ले जाया गया",
      "ja": "リソースは新しい場所に永続的に移動しました",
      "ko": "리소스가 새 위치로 영구 이동됨"
    },
    "302": {
      "zh-TW": "資源臨時位於其他位置",
      "zh-CN": "资源临时位于其他位置",
      "en": "Resource temporarily located elsewhere",
      "hi": "संसाधन अस्थायी रूप से कहीं और स्थित",
      "ja": "リソースは一時的に別の場所にあります",
      "ko": "리소스가 일시적으로 다른 위치에 있음"
    },
    "303": {
      "zh-TW": "應使用 GET 方法獲取另一個 URI",
      "zh-CN": "应使用 GET 方法获取另一个 URI",
      "en": "Use GET to retrieve resource at another URI",
      "hi": "अन्य URI पर संसाधन प्राप्त करने के लिए GET का उपयोग करें",
      "ja": "別のURIでリソースを取得するにはGETを使用してください",
      "ko": "다른 URI에서 리소스를 가져오려면 GET 사용"
    },
    "304": {
      "zh-TW": "資源未修改，可使用緩存版本",
      "zh-CN": "资源未修改，可使用缓存版本",
      "en": "Resource not modified, use cached version",
      "hi": "संसाधन संशोधित नहीं, कैश्ड संस्करण का उपयोग करें",
      "ja": "リソースは変更されていません、キャッシュ版を使用",
      "ko": "리소스가 수정되지 않음, 캐시된 버전 사용"
    },
    "305": {
      "zh-TW": "必須通過代理訪問",
      "zh-CN": "必须通过代理访问",
      "en": "Must be accessed through a proxy",
      "hi": "प्रॉक्सी के माध्यम से एक्सेस करना होगा",
      "ja": "プロキシ経由でアクセスする必要があります",
      "ko": "프록시를 통해 액세스해야 함"
    },
    "307": {
      "zh-TW": "臨時重新導向，使用相同方法",
      "zh-CN": "临时重定向，使用相同方法",
      "en": "Temporary redirect with same method",
      "hi": "समान विधि के साथ अस्थायी रीडायरेक्ट",
      "ja": "同じメソッドで一時リダイレクト",
      "ko": "동일한 메서드로 임시 리디렉션"
    },
    "308": {
      "zh-TW": "永久重新導向，使用相同方法",
      "zh-CN": "永久重定向，使用相同方法",
      "en": "Permanent redirect with same method",
      "hi": "समान विधि के साथ स्थायी रीडायरेक्ट",
      "ja": "同じメソッドで永続リダイレクト",
      "ko": "동일한 메서드로 영구 리디렉션"
    },
    "400": {
      "zh-TW": "伺服器無法理解請求",
      "zh-CN": "服务器无法理解请求",
      "en": "Server cannot understand the request",
      "hi": "सर्वर अनुरोध को समझ नहीं सकता",
      "ja": "サーバーはリクエストを理解できません",
      "ko": "서버가 요청을 이해할 수 없음"
    },
    "401": {
      "zh-TW": "需要身份驗證",
      "zh-CN": "需要身份验证",
      "en": "Authentication required",
      "hi": "प्रमाणीकरण आवश्यक",
      "ja": "認証が必要です",
      "ko": "인증 필요"
    },
    "402": {
      "zh-TW": "需要付款（保留供將來使用）",
      "zh-CN": "需要付款（保留供将来使用）",
      "en": "Payment required (reserved for future use)",
      "hi": "भुगतान आवश्यक (भविष्य के उपयोग के लिए आरक्षित)",
      "ja": "支払いが必要（将来の使用のために予約）",
      "ko": "결제 필요 (향후 사용을 위해 예약됨)"
    },
    "403": {
      "zh-TW": "伺服器拒絕執行請求",
      "zh-CN": "服务器拒绝执行请求",
      "en": "Server refuses to fulfill the request",
      "hi": "सर्वर अनुरोध पूरा करने से इनकार करता है",
      "ja": "サーバーはリクエストの実行を拒否しています",
      "ko": "서버가 요청 처리를 거부함"
    },
    "404": {
      "zh-TW": "找不到請求的資源",
      "zh-CN": "找不到请求的资源",
      "en": "Requested resource not found",
      "hi": "अनुरोधित संसाधन नहीं मिला",
      "ja": "リクエストされたリソースが見つかりません",
      "ko": "요청한 리소스를 찾을 수 없음"
    },
    "405": {
      "zh-TW": "不允許使用此方法",
      "zh-CN": "不允许使用此方法",
      "en": "Method not allowed",
      "hi": "विधि की अनुमति नहीं",
      "ja": "メソッドは許可されていません",
      "ko": "메서드가 허용되지 않음"
    },
    "406": {
      "zh-TW": "無法提供符合要求的內容",
      "zh-CN": "无法提供符合要求的内容",
      "en": "Cannot provide content matching requirements",
      "hi": "आवश्यकताओं से मेल खाने वाली सामग्री प्रदान नहीं कर सकता",
      "ja": "要件に合うコンテンツを提供できません",
      "ko": "요구 사항에 맞는 콘텐츠를 제공할 수 없음"
    },
    "407": {
      "zh-TW": "需要代理身份驗證",
      "zh-CN": "需要代理身份验证",
      "en": "Proxy authentication required",
      "hi": "प्रॉक्सी प्रमाणीकरण आवश्यक",
      "ja": "プロキシ認証が必要です",
      "ko": "프록시 인증 필요"
    },
    "408": {
      "zh-TW": "請求超時",
      "zh-CN": "请求超时",
      "en": "Request timeout",
      "hi": "अनुरोध टाइमआउट",
      "ja": "リクエストタイムアウト",
      "ko": "요청 시간 초과"
    },
    "409": {
      "zh-TW": "請求與當前狀態衝突",
      "zh-CN": "请求与当前状态冲突",
      "en": "Request conflicts with current state",
      "hi": "अनुरोध वर्तमान स्थिति से विरोधाभासी",
      "ja": "リクエストが現在の状態と競合しています",
      "ko": "요청이 현재 상태와 충돌함"
    },
    "410": {
      "zh-TW": "資源已永久刪除",
      "zh-CN": "资源已永久删除",
      "en": "Resource permanently deleted",
      "hi": "संसाधन स्थायी रूप से हटाया गया",
      "ja": "リソースは永続的に削除されました",
      "ko": "리소스가 영구 삭제됨"
    },
    "411": {
      "zh-TW": "需要 Content-Length 標頭",
      "zh-CN": "需要 Content-Length 标头",
      "en": "Content-Length header required",
      "hi": "Content-Length हेडर आवश्यक",
      "ja": "Content-Lengthヘッダーが必要です",
      "ko": "Content-Length 헤더 필요"
    },
    "412": {
      "zh-TW": "前置條件失敗",
      "zh-CN": "前置条件失败",
      "en": "Precondition failed",
      "hi": "पूर्व शर्त विफल",
      "ja": "前提条件が失敗しました",
      "ko": "전제 조건 실패"
    },
    "413": {
      "zh-TW": "請求內容過大",
      "zh-CN": "请求内容过大",
      "en": "Request payload too large",
      "hi": "अनुरोध पेलोड बहुत बड़ा",
      "ja": "リクエストペイロードが大きすぎます",
      "ko": "요청 페이로드가 너무 큼"
    },
    "414": {
      "zh-TW": "URI 過長",
      "zh-CN": "URI 过长",
      "en": "URI too long",
      "hi": "URI बहुत लंबा",
      "ja": "URIが長すぎます",
      "ko": "URI가 너무 김"
    },
    "415": {
      "zh-TW": "不支援的媒體類型",
      "zh-CN": "不支持的媒体类型",
      "en": "Unsupported media type",
      "hi": "असमर्थित मीडिया प्रकार",
      "ja": "サポートされていないメディアタイプ",
      "ko": "지원되지 않는 미디어 유형"
    },
    "416": {
      "zh-TW": "無法滿足範圍請求",
      "zh-CN": "无法满足范围请求",
      "en": "Range not satisfiable",
      "hi": "रेंज संतोषजनक नहीं",
      "ja": "範囲を満たせません",
      "ko": "범위를 충족할 수 없음"
    },
    "417": {
      "zh-TW": "期望標頭無法滿足",
      "zh-CN": "期望标头无法满足",
      "en": "Expectation header cannot be met",
      "hi": "अपेक्षा हेडर पूरा नहीं किया जा सकता",
      "ja": "Expectヘッダーを満たせません",
      "ko": "Expect 헤더를 충족할 수 없음"
    },
    "418": {
      "zh-TW": "我是茶壺（愚人節彩蛋）",
      "zh-CN": "我是茶壶（愚人节彩蛋）",
      "en": "I'm a teapot (April Fools' joke)",
      "hi": "मैं एक चायदानी हूं (अप्रैल फूल मजाक)",
      "ja": "私はティーポットです（エイプリルフール）",
      "ko": "나는 찻주전자입니다 (만우절 농담)"
    },
    "421": {
      "zh-TW": "請求被導向到無法產生回應的伺服器",
      "zh-CN": "请求被导向到无法产生响应的服务器",
      "en": "Request directed to a server unable to produce response",
      "hi": "अनुरोध ऐसे सर्वर पर निर्देशित जो प्रतिक्रिया देने में असमर्थ",
      "ja": "応答を生成できないサーバーへのリクエスト",
      "ko": "응답을 생성할 수 없는 서버로 요청이 전달됨"
    },
    "422": {
      "zh-TW": "請求格式正確但語義錯誤",
      "zh-CN": "请求格式正确但语义错误",
      "en": "Request well-formed but semantically incorrect",
      "hi": "अनुरोध सही प्रारूप लेकिन शब्दार्थ रूप से गलत",
      "ja": "リクエストの形式は正しいが意味的に不正",
      "ko": "요청 형식은 올바르지만 의미적으로 오류"
    },
    "423": {
      "zh-TW": "資源已鎖定",
      "zh-CN": "资源已锁定",
      "en": "Resource is locked",
      "hi": "संसाधन लॉक है",
      "ja": "リソースはロックされています",
      "ko": "리소스가 잠김"
    },
    "424": {
      "zh-TW": "由於先前請求失敗導致此請求失敗",
      "zh-CN": "由于先前请求失败导致此请求失败",
      "en": "Request failed due to previous request failure",
      "hi": "पिछले अनुरोध की विफलता के कारण अनुरोध विफल",
      "ja": "前のリクエストの失敗によりこのリクエストが失敗",
      "ko": "이전 요청 실패로 인해 요청 실패"
    },
    "425": {
      "zh-TW": "伺服器不願意冒險處理可能被重播的請求",
      "zh-CN": "服务器不愿意冒险处理可能被重放的请求",
      "en": "Server unwilling to risk processing a request that might be replayed",
      "hi": "सर्वर ऐसे अनुरोध को संसाधित करने का जोखिम नहीं उठाना चाहता जो फिर से चलाया जा सकता है",
      "ja": "サーバーは再生される可能性のあるリクエストを処理するリスクを取りたくありません",
      "ko": "서버가 재생될 수 있는 요청을 처리하는 위험을 감수하지 않음"
    },
    "426": {
      "zh-TW": "需要升級協議",
      "zh-CN": "需要升级协议",
      "en": "Upgrade required",
      "hi": "अपग्रेड आवश्यक",
      "ja": "アップグレードが必要です",
      "ko": "업그레이드 필요"
    },
    "428": {
      "zh-TW": "需要前置條件",
      "zh-CN": "需要前置条件",
      "en": "Precondition required",
      "hi": "पूर्व शर्त आवश्यक",
      "ja": "前提条件が必要です",
      "ko": "전제 조건 필요"
    },
    "429": {
      "zh-TW": "請求過多，超出速率限制",
      "zh-CN": "请求过多，超出速率限制",
      "en": "Too many requests, rate limit exceeded",
      "hi": "बहुत अधिक अनुरोध, दर सीमा पार",
      "ja": "リクエストが多すぎます、レート制限を超過",
      "ko": "요청이 너무 많음, 속도 제한 초과"
    },
    "431": {
      "zh-TW": "請求標頭欄位過大",
      "zh-CN": "请求标头字段过大",
      "en": "Request header fields too large",
      "hi": "अनुरोध हेडर फ़ील्ड बहुत बड़े",
      "ja": "リクエストヘッダーフィールドが大きすぎます",
      "ko": "요청 헤더 필드가 너무 큼"
    },
    "451": {
      "zh-TW": "因法律原因不可用",
      "zh-CN": "因法律原因不可用",
      "en": "Unavailable for legal reasons",
      "hi": "कानूनी कारणों से अनुपलब्ध",
      "ja": "法的理由により利用不可",
      "ko": "법적 사유로 이용 불가"
    },
    "500": {
      "zh-TW": "伺服器內部錯誤",
      "zh-CN": "服务器内部错误",
      "en": "Internal server error",
      "hi": "आंतरिक सर्वर त्रुटि",
      "ja": "サーバー内部エラー",
      "ko": "내부 서버 오류"
    },
    "501": {
      "zh-TW": "伺服器不支援所需功能",
      "zh-CN": "服务器不支持所需功能",
      "en": "Server does not support required functionality",
      "hi": "सर्वर आवश्यक कार्यक्षमता का समर्थन नहीं करता",
      "ja": "サーバーは必要な機能をサポートしていません",
      "ko": "서버가 필요한 기능을 지원하지 않음"
    },
    "502": {
      "zh-TW": "閘道器從上游伺服器收到無效回應",
      "zh-CN": "网关从上游服务器收到无效响应",
      "en": "Gateway received invalid response from upstream server",
      "hi": "गेटवे को अपस्ट्रीम सर्वर से अमान्य प्रतिक्रिया मिली",
      "ja": "ゲートウェイが上流サーバーから無効な応答を受信",
      "ko": "게이트웨이가 업스트림 서버에서 잘못된 응답을 수신함"
    },
    "503": {
      "zh-TW": "服務暫時不可用",
      "zh-CN": "服务暂时不可用",
      "en": "Service temporarily unavailable",
      "hi": "सेवा अस्थायी रूप से अनुपलब्ध",
      "ja": "サービスは一時的に利用できません",
      "ko": "서비스를 일시적으로 사용할 수 없음"
    },
    "504": {
      "zh-TW": "閘道器超時",
      "zh-CN": "网关超时",
      "en": "Gateway timeout",
      "hi": "गेटवे टाइमआउट",
      "ja": "ゲートウェイタイムアウト",
      "ko": "게이트웨이 시간 초과"
    },
    "505": {
      "zh-TW": "不支援的 HTTP 版本",
      "zh-CN": "不支持的 HTTP 版本",
      "en": "HTTP version not supported",
      "hi": "HTTP संस्करण समर्थित नहीं",
      "ja": "HTTPバージョンはサポートされていません",
      "ko": "HTTP 버전이 지원되지 않음"
    },
    "506": {
      "zh-TW": "內容協商產生循環參考",
      "zh-CN": "内容协商产生循环引用",
      "en": "Content negotiation created circular reference",
      "hi": "सामग्री वार्ता ने परिपत्र संदर्भ बनाया",
      "ja": "コンテンツネゴシエーションで循環参照が発生",
      "ko": "콘텐츠 협상으로 순환 참조 발생"
    },
    "507": {
      "zh-TW": "儲存空間不足",
      "zh-CN": "存储空间不足",
      "en": "Insufficient storage",
      "hi": "अपर्याप्त भंडारण",
      "ja": "ストレージ不足",
      "ko": "저장 공간 부족"
    },
    "508": {
      "zh-TW": "偵測到迴圈",
      "zh-CN": "检测到循环",
      "en": "Loop detected",
      "hi": "लूप का पता चला",
      "ja": "ループが検出されました",
      "ko": "루프 감지됨"
    },
    "510": {
      "zh-TW": "需要進一步擴展請求",
      "zh-CN": "需要进一步扩展请求",
      "en": "Further extensions required",
      "hi": "और विस्तार आवश्यक",
      "ja": "さらなる拡張が必要です",
      "ko": "추가 확장 필요"
    },
    "511": {
      "zh-TW": "需要網路身份驗證",
      "zh-CN": "需要网络身份验证",
      "en": "Network authentication required",
      "hi": "नेटवर्क प्रमाणीकरण आवश्यक",
      "ja": "ネットワーク認証が必要です",
      "ko": "네트워크 인증 필요"
    }
  },

  // Cron 表達式解析器
  "cronParser": {
    "title": {
      "zh-TW": "Cron 表達式解析器",
      "zh-CN": "Cron 表达式解析器",
      "en": "Cron Expression Parser",
      "hi": "Cron एक्सप्रेशन पार्सर",
      "ja": "Cron式パーサー",
      "ko": "Cron 표현식 파서"
    },
    "description": {
      "zh-TW": "解析和生成 Cron 表達式，顯示人類可讀的執行時間",
      "zh-CN": "解析和生成 Cron 表达式，显示人类可读的执行时间",
      "en": "Parse and generate Cron expressions with human-readable execution times",
      "hi": "मानव-पठनीय निष्पादन समय के साथ Cron एक्सप्रेशन पार्स और जेनरेट करें",
      "ja": "人間が読める実行時間でCron式を解析・生成",
      "ko": "사람이 읽을 수 있는 실행 시간으로 Cron 표현식 파싱 및 생성"
    },
    "expression": {
      "zh-TW": "Cron 表達式",
      "zh-CN": "Cron 表达式",
      "en": "Cron Expression",
      "hi": "Cron एक्सप्रेशन",
      "ja": "Cron式",
      "ko": "Cron 표현식"
    },
    "expressionPlaceholder": {
      "zh-TW": "例如：0 0 * * * 或 */5 * * * *",
      "zh-CN": "例如：0 0 * * * 或 */5 * * * *",
      "en": "e.g., 0 0 * * * or */5 * * * *",
      "hi": "जैसे: 0 0 * * * या */5 * * * *",
      "ja": "例: 0 0 * * * または */5 * * * *",
      "ko": "예: 0 0 * * * 또는 */5 * * * *"
    },
    "humanReadable": {
      "zh-TW": "人類可讀格式",
      "zh-CN": "人类可读格式",
      "en": "Human Readable",
      "hi": "मानव पठनीय",
      "ja": "人間が読める形式",
      "ko": "사람이 읽을 수 있는 형식"
    },
    "nextExecutions": {
      "zh-TW": "下次執行時間",
      "zh-CN": "下次执行时间",
      "en": "Next Executions",
      "hi": "अगले निष्पादन",
      "ja": "次回の実行",
      "ko": "다음 실행"
    },
    "minute": {
      "zh-TW": "分鐘",
      "zh-CN": "分钟",
      "en": "Minute",
      "hi": "मिनट",
      "ja": "分",
      "ko": "분"
    },
    "hour": {
      "zh-TW": "小時",
      "zh-CN": "小时",
      "en": "Hour",
      "hi": "घंटा",
      "ja": "時",
      "ko": "시"
    },
    "dayOfMonth": {
      "zh-TW": "日",
      "zh-CN": "日",
      "en": "Day of Month",
      "hi": "महीने का दिन",
      "ja": "日",
      "ko": "일"
    },
    "month": {
      "zh-TW": "月",
      "zh-CN": "月",
      "en": "Month",
      "hi": "महीना",
      "ja": "月",
      "ko": "월"
    },
    "dayOfWeek": {
      "zh-TW": "星期",
      "zh-CN": "星期",
      "en": "Day of Week",
      "hi": "सप्ताह का दिन",
      "ja": "曜日",
      "ko": "요일"
    },
    "presets": {
      "zh-TW": "常用表達式",
      "zh-CN": "常用表达式",
      "en": "Common Presets",
      "hi": "सामान्य प्रीसेट",
      "ja": "よく使う式",
      "ko": "자주 사용하는 표현식"
    },
    "everyMinute": {
      "zh-TW": "每分鐘",
      "zh-CN": "每分钟",
      "en": "Every minute",
      "hi": "हर मिनट",
      "ja": "毎分",
      "ko": "매분"
    },
    "everyHour": {
      "zh-TW": "每小時",
      "zh-CN": "每小时",
      "en": "Every hour",
      "hi": "हर घंटे",
      "ja": "毎時",
      "ko": "매시간"
    },
    "everyDay": {
      "zh-TW": "每天",
      "zh-CN": "每天",
      "en": "Every day",
      "hi": "हर दिन",
      "ja": "毎日",
      "ko": "매일"
    },
    "everyWeek": {
      "zh-TW": "每週",
      "zh-CN": "每周",
      "en": "Every week",
      "hi": "हर हफ्ते",
      "ja": "毎週",
      "ko": "매주"
    },
    "everyMonth": {
      "zh-TW": "每月",
      "zh-CN": "每月",
      "en": "Every month",
      "hi": "हर महीने",
      "ja": "毎月",
      "ko": "매월"
    },
    "invalidExpression": {
      "zh-TW": "無效的 Cron 表達式",
      "zh-CN": "无效的 Cron 表达式",
      "en": "Invalid Cron expression",
      "hi": "अमान्य Cron एक्सप्रेशन",
      "ja": "無効なCron式",
      "ko": "잘못된 Cron 표현식"
    },
    "generator": {
      "zh-TW": "表達式生成器",
      "zh-CN": "表达式生成器",
      "en": "Expression Generator",
      "hi": "एक्सप्रेशन जेनरेटर",
      "ja": "式ジェネレーター",
      "ko": "표현식 생성기"
    },
    "every": {
      "zh-TW": "每",
      "zh-CN": "每",
      "en": "Every",
      "hi": "हर",
      "ja": "毎",
      "ko": "매"
    },
    "at": {
      "zh-TW": "在",
      "zh-CN": "在",
      "en": "At",
      "hi": "पर",
      "ja": "に",
      "ko": "에"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "即時解析",
      "zh-CN": "即时解析",
      "en": "Real-time Parsing",
      "hi": "रीयल-टाइम पार्सिंग",
      "ja": "リアルタイム解析",
      "ko": "실시간 파싱"
    },
    "feature1Description": {
      "zh-TW": "輸入時即時顯示解析結果",
      "zh-CN": "输入时即时显示解析结果",
      "en": "See parsing results as you type",
      "hi": "टाइप करते समय पार्सिंग परिणाम देखें",
      "ja": "入力しながら解析結果を確認",
      "ko": "입력하면서 파싱 결과 확인"
    },
    "feature2Title": {
      "zh-TW": "執行預覽",
      "zh-CN": "执行预览",
      "en": "Execution Preview",
      "hi": "निष्पादन पूर्वावलोकन",
      "ja": "実行プレビュー",
      "ko": "실행 미리보기"
    },
    "feature2Description": {
      "zh-TW": "顯示未來執行時間列表",
      "zh-CN": "显示未来执行时间列表",
      "en": "Show list of future execution times",
      "hi": "भविष्य के निष्पादन समय की सूची दिखाएं",
      "ja": "将来の実行時間リストを表示",
      "ko": "미래 실행 시간 목록 표시"
    },
    "placeholder": {
      "zh-TW": "輸入 Cron 表達式...",
      "zh-CN": "输入 Cron 表达式...",
      "en": "Enter Cron expression...",
      "hi": "Cron एक्सप्रेशन दर्ज करें...",
      "ja": "Cron式を入力...",
      "ko": "Cron 표현식 입력..."
    },
    "second": {
      "zh-TW": "秒",
      "zh-CN": "秒",
      "en": "Second",
      "hi": "सेकंड",
      "ja": "秒",
      "ko": "초"
    },
    "meaning": {
      "zh-TW": "含義",
      "zh-CN": "含义",
      "en": "Meaning",
      "hi": "अर्थ",
      "ja": "意味",
      "ko": "의미"
    },
    "every5Minutes": {
      "zh-TW": "每 5 分鐘",
      "zh-CN": "每 5 分钟",
      "en": "Every 5 minutes",
      "hi": "हर 5 मिनट",
      "ja": "5分ごと",
      "ko": "5분마다"
    },
    "every10Minutes": {
      "zh-TW": "每 10 分鐘",
      "zh-CN": "每 10 分钟",
      "en": "Every 10 minutes",
      "hi": "हर 10 मिनट",
      "ja": "10分ごと",
      "ko": "10분마다"
    },
    "every15Minutes": {
      "zh-TW": "每 15 分鐘",
      "zh-CN": "每 15 分钟",
      "en": "Every 15 minutes",
      "hi": "हर 15 मिनट",
      "ja": "15分ごと",
      "ko": "15분마다"
    },
    "every30Minutes": {
      "zh-TW": "每 30 分鐘",
      "zh-CN": "每 30 分钟",
      "en": "Every 30 minutes",
      "hi": "हर 30 मिनट",
      "ja": "30分ごと",
      "ko": "30분마다"
    },
    "every2Hours": {
      "zh-TW": "每 2 小時",
      "zh-CN": "每 2 小时",
      "en": "Every 2 hours",
      "hi": "हर 2 घंटे",
      "ja": "2時間ごと",
      "ko": "2시간마다"
    },
    "every4Hours": {
      "zh-TW": "每 4 小時",
      "zh-CN": "每 4 小时",
      "en": "Every 4 hours",
      "hi": "हर 4 घंटे",
      "ja": "4時間ごと",
      "ko": "4시간마다"
    },
    "every6Hours": {
      "zh-TW": "每 6 小時",
      "zh-CN": "每 6 小时",
      "en": "Every 6 hours",
      "hi": "हर 6 घंटे",
      "ja": "6時間ごと",
      "ko": "6시간마다"
    },
    "every12Hours": {
      "zh-TW": "每 12 小時",
      "zh-CN": "每 12 小时",
      "en": "Every 12 hours",
      "hi": "हर 12 घंटे",
      "ja": "12時間ごと",
      "ko": "12시간마다"
    },
    "weekdays": {
      "zh-TW": "工作日",
      "zh-CN": "工作日",
      "en": "Weekdays",
      "hi": "कार्यदिवस",
      "ja": "平日",
      "ko": "평일"
    },
    "weekends": {
      "zh-TW": "週末",
      "zh-CN": "周末",
      "en": "Weekends",
      "hi": "सप्ताहांत",
      "ja": "週末",
      "ko": "주말"
    },
    "generatedExpression": {
      "zh-TW": "生成的表達式",
      "zh-CN": "生成的表达式",
      "en": "Generated Expression",
      "hi": "जेनरेटेड एक्सप्रेशन",
      "ja": "生成された式",
      "ko": "생성된 표현식"
    },
    "use": {
      "zh-TW": "使用",
      "zh-CN": "使用",
      "en": "Use",
      "hi": "उपयोग करें",
      "ja": "使用",
      "ko": "사용"
    },
    "commonExpressions": {
      "zh-TW": "常用表達式",
      "zh-CN": "常用表达式",
      "en": "Common Expressions",
      "hi": "सामान्य एक्सप्रेशन",
      "ja": "よく使う式",
      "ko": "자주 사용하는 표현식"
    },
    "syntax": {
      "zh-TW": "語法說明",
      "zh-CN": "语法说明",
      "en": "Syntax Reference",
      "hi": "सिंटैक्स संदर्भ",
      "ja": "構文リファレンス",
      "ko": "구문 참조"
    },
    "symbol": {
      "zh-TW": "符號",
      "zh-CN": "符号",
      "en": "Symbol",
      "hi": "प्रतीक",
      "ja": "記号",
      "ko": "기호"
    },
    "example": {
      "zh-TW": "範例",
      "zh-CN": "示例",
      "en": "Example",
      "hi": "उदाहरण",
      "ja": "例",
      "ko": "예시"
    },
    "anyValue": {
      "zh-TW": "任意值",
      "zh-CN": "任意值",
      "en": "Any value",
      "hi": "कोई भी मान",
      "ja": "任意の値",
      "ko": "임의의 값"
    },
    "valueList": {
      "zh-TW": "值列表",
      "zh-CN": "值列表",
      "en": "Value list",
      "hi": "मान सूची",
      "ja": "値リスト",
      "ko": "값 목록"
    },
    "range": {
      "zh-TW": "範圍",
      "zh-CN": "范围",
      "en": "Range",
      "hi": "सीमा",
      "ja": "範囲",
      "ko": "범위"
    },
    "step": {
      "zh-TW": "步進",
      "zh-CN": "步进",
      "en": "Step",
      "hi": "स्टेप",
      "ja": "ステップ",
      "ko": "스텝"
    }
  },

  // JSON Schema 驗證器
  "jsonSchemaValidator": {
    "title": {
      "zh-TW": "JSON Schema 驗證器",
      "zh-CN": "JSON Schema 验证器",
      "en": "JSON Schema Validator",
      "hi": "JSON स्कीमा वैलिडेटर",
      "ja": "JSON Schemaバリデーター",
      "ko": "JSON 스키마 검증기"
    },
    "description": {
      "zh-TW": "使用 JSON Schema 驗證 JSON 資料結構",
      "zh-CN": "使用 JSON Schema 验证 JSON 数据结构",
      "en": "Validate JSON data structure with JSON Schema",
      "hi": "JSON स्कीमा के साथ JSON डेटा संरचना को मान्य करें",
      "ja": "JSON Schemaを使用してJSONデータ構造を検証",
      "ko": "JSON 스키마로 JSON 데이터 구조 검증"
    },
    "schema": {
      "zh-TW": "JSON Schema",
      "zh-CN": "JSON Schema",
      "en": "JSON Schema",
      "hi": "JSON स्कीमा",
      "ja": "JSON Schema",
      "ko": "JSON 스키마"
    },
    "schemaPlaceholder": {
      "zh-TW": "輸入 JSON Schema...",
      "zh-CN": "输入 JSON Schema...",
      "en": "Enter JSON Schema...",
      "hi": "JSON स्कीमा दर्ज करें...",
      "ja": "JSON Schemaを入力...",
      "ko": "JSON 스키마 입력..."
    },
    "jsonData": {
      "zh-TW": "JSON 資料",
      "zh-CN": "JSON 数据",
      "en": "JSON Data",
      "hi": "JSON डेटा",
      "ja": "JSONデータ",
      "ko": "JSON 데이터"
    },
    "jsonDataPlaceholder": {
      "zh-TW": "輸入要驗證的 JSON 資料...",
      "zh-CN": "输入要验证的 JSON 数据...",
      "en": "Enter JSON data to validate...",
      "hi": "मान्य करने के लिए JSON डेटा दर्ज करें...",
      "ja": "検証するJSONデータを入力...",
      "ko": "검증할 JSON 데이터 입력..."
    },
    "validate": {
      "zh-TW": "驗證",
      "zh-CN": "验证",
      "en": "Validate",
      "hi": "मान्य करें",
      "ja": "検証",
      "ko": "검증"
    },
    "validationResult": {
      "zh-TW": "驗證結果",
      "zh-CN": "验证结果",
      "en": "Validation Result",
      "hi": "मान्यता परिणाम",
      "ja": "検証結果",
      "ko": "검증 결과"
    },
    "valid": {
      "zh-TW": "驗證通過",
      "zh-CN": "验证通过",
      "en": "Valid",
      "hi": "मान्य",
      "ja": "有効",
      "ko": "유효함"
    },
    "invalid": {
      "zh-TW": "驗證失敗",
      "zh-CN": "验证失败",
      "en": "Invalid",
      "hi": "अमान्य",
      "ja": "無効",
      "ko": "유효하지 않음"
    },
    "errors": {
      "zh-TW": "錯誤",
      "zh-CN": "错误",
      "en": "Errors",
      "hi": "त्रुटियां",
      "ja": "エラー",
      "ko": "오류"
    },
    "path": {
      "zh-TW": "路徑",
      "zh-CN": "路径",
      "en": "Path",
      "hi": "पथ",
      "ja": "パス",
      "ko": "경로"
    },
    "message": {
      "zh-TW": "訊息",
      "zh-CN": "消息",
      "en": "Message",
      "hi": "संदेश",
      "ja": "メッセージ",
      "ko": "메시지"
    },
    "sampleSchemas": {
      "zh-TW": "範例 Schema",
      "zh-CN": "示例 Schema",
      "en": "Sample Schemas",
      "hi": "नमूना स्कीमा",
      "ja": "サンプルSchema",
      "ko": "샘플 스키마"
    },
    "simpleObject": {
      "zh-TW": "簡單物件",
      "zh-CN": "简单对象",
      "en": "Simple Object",
      "hi": "सिंपल ऑब्जेक्ट",
      "ja": "シンプルオブジェクト",
      "ko": "간단한 객체"
    },
    "arrayItems": {
      "zh-TW": "陣列驗證",
      "zh-CN": "数组验证",
      "en": "Array Validation",
      "hi": "एरे वैलिडेशन",
      "ja": "配列検証",
      "ko": "배열 검증"
    },
    "nestedObject": {
      "zh-TW": "巢狀物件",
      "zh-CN": "嵌套对象",
      "en": "Nested Object",
      "hi": "नेस्टेड ऑब्जेक्ट",
      "ja": "ネストされたオブジェクト",
      "ko": "중첩된 객체"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "完整支援",
      "zh-CN": "完整支持",
      "en": "Full Support",
      "hi": "पूर्ण समर्थन",
      "ja": "完全サポート",
      "ko": "완전 지원"
    },
    "feature1Description": {
      "zh-TW": "支援 JSON Schema Draft-07 規範",
      "zh-CN": "支持 JSON Schema Draft-07 规范",
      "en": "Supports JSON Schema Draft-07 specification",
      "hi": "JSON स्कीमा ड्राफ्ट-07 विनिर्देश का समर्थन",
      "ja": "JSON Schema Draft-07仕様をサポート",
      "ko": "JSON 스키마 Draft-07 사양 지원"
    },
    "feature2Title": {
      "zh-TW": "詳細錯誤",
      "zh-CN": "详细错误",
      "en": "Detailed Errors",
      "hi": "विस्तृत त्रुटियां",
      "ja": "詳細なエラー",
      "ko": "상세한 오류"
    },
    "feature2Description": {
      "zh-TW": "提供精確的錯誤位置和說明",
      "zh-CN": "提供精确的错误位置和说明",
      "en": "Provides precise error locations and descriptions",
      "hi": "सटीक त्रुटि स्थान और विवरण प्रदान करता है",
      "ja": "正確なエラー位置と説明を提供",
      "ko": "정확한 오류 위치와 설명 제공"
    },
    "commonSchemas": {
      "zh-TW": "常用 Schema",
      "zh-CN": "常用 Schema",
      "en": "Common Schemas",
      "hi": "सामान्य स्कीमा",
      "ja": "一般的なSchema",
      "ko": "일반 스키마"
    },
    "dataPlaceholder": {
      "zh-TW": "輸入要驗證的資料...",
      "zh-CN": "输入要验证的数据...",
      "en": "Enter data to validate...",
      "hi": "मान्य करने के लिए डेटा दर्ज करें...",
      "ja": "検証するデータを入力...",
      "ko": "검증할 데이터 입력..."
    },
    "result": {
      "zh-TW": "結果",
      "zh-CN": "结果",
      "en": "Result",
      "hi": "परिणाम",
      "ja": "結果",
      "ko": "결과"
    },
    "schemaVersion": {
      "zh-TW": "Schema 版本",
      "zh-CN": "Schema 版本",
      "en": "Schema Version",
      "hi": "स्कीमा संस्करण",
      "ja": "Schemaバージョン",
      "ko": "스키마 버전"
    },
    "validJson": {
      "zh-TW": "有效的 JSON",
      "zh-CN": "有效的 JSON",
      "en": "Valid JSON",
      "hi": "मान्य JSON",
      "ja": "有効なJSON",
      "ko": "유효한 JSON"
    },
    "validSchema": {
      "zh-TW": "有效的 Schema",
      "zh-CN": "有效的 Schema",
      "en": "Valid Schema",
      "hi": "मान्य स्कीमा",
      "ja": "有効なSchema",
      "ko": "유효한 스키마"
    },
    "validationFailed": {
      "zh-TW": "驗證失敗",
      "zh-CN": "验证失败",
      "en": "Validation Failed",
      "hi": "मान्यता विफल",
      "ja": "検証失敗",
      "ko": "검증 실패"
    },
    "validationPassed": {
      "zh-TW": "驗證通過",
      "zh-CN": "验证通过",
      "en": "Validation Passed",
      "hi": "मान्यता पास",
      "ja": "検証成功",
      "ko": "검증 통과"
    },
    "validationPassedDesc": {
      "zh-TW": "JSON 資料符合 Schema 規範",
      "zh-CN": "JSON 数据符合 Schema 规范",
      "en": "JSON data conforms to the Schema",
      "hi": "JSON डेटा स्कीमा के अनुरूप है",
      "ja": "JSONデータがSchemaに準拠しています",
      "ko": "JSON 데이터가 스키마에 부합합니다"
    }
  },

  // JSON ↔ YAML 轉換器
  "jsonYamlConverter": {
    "title": {
      "zh-TW": "JSON ↔ YAML 轉換器",
      "zh-CN": "JSON ↔ YAML 转换器",
      "en": "JSON ↔ YAML Converter",
      "hi": "JSON ↔ YAML कनवर्टर",
      "ja": "JSON ↔ YAML変換",
      "ko": "JSON ↔ YAML 변환기"
    },
    "description": {
      "zh-TW": "在 JSON 和 YAML 格式之間快速轉換",
      "zh-CN": "在 JSON 和 YAML 格式之间快速转换",
      "en": "Quickly convert between JSON and YAML formats",
      "hi": "JSON और YAML प्रारूपों के बीच तुरंत रूपांतरण करें",
      "ja": "JSONとYAML形式間を素早く変換",
      "ko": "JSON과 YAML 형식 간 빠른 변환"
    },
    "jsonInput": {
      "zh-TW": "JSON 輸入",
      "zh-CN": "JSON 输入",
      "en": "JSON Input",
      "hi": "JSON इनपुट",
      "ja": "JSON入力",
      "ko": "JSON 입력"
    },
    "yamlInput": {
      "zh-TW": "YAML 輸入",
      "zh-CN": "YAML 输入",
      "en": "YAML Input",
      "hi": "YAML इनपुट",
      "ja": "YAML入力",
      "ko": "YAML 입력"
    },
    "jsonOutput": {
      "zh-TW": "JSON 輸出",
      "zh-CN": "JSON 输出",
      "en": "JSON Output",
      "hi": "JSON आउटपुट",
      "ja": "JSON出力",
      "ko": "JSON 출력"
    },
    "yamlOutput": {
      "zh-TW": "YAML 輸出",
      "zh-CN": "YAML 输出",
      "en": "YAML Output",
      "hi": "YAML आउटपुट",
      "ja": "YAML出力",
      "ko": "YAML 출력"
    },
    "toYaml": {
      "zh-TW": "轉換為 YAML →",
      "zh-CN": "转换为 YAML →",
      "en": "Convert to YAML →",
      "hi": "YAML में बदलें →",
      "ja": "YAMLに変換 →",
      "ko": "YAML로 변환 →"
    },
    "toJson": {
      "zh-TW": "← 轉換為 JSON",
      "zh-CN": "← 转换为 JSON",
      "en": "← Convert to JSON",
      "hi": "← JSON में बदलें",
      "ja": "← JSONに変換",
      "ko": "← JSON으로 변환"
    },
    "jsonPlaceholder": {
      "zh-TW": "輸入 JSON...",
      "zh-CN": "输入 JSON...",
      "en": "Enter JSON...",
      "hi": "JSON दर्ज करें...",
      "ja": "JSONを入力...",
      "ko": "JSON 입력..."
    },
    "yamlPlaceholder": {
      "zh-TW": "輸入 YAML...",
      "zh-CN": "输入 YAML...",
      "en": "Enter YAML...",
      "hi": "YAML दर्ज करें...",
      "ja": "YAMLを入力...",
      "ko": "YAML 입력..."
    },
    "invalidJson": {
      "zh-TW": "無效的 JSON",
      "zh-CN": "无效的 JSON",
      "en": "Invalid JSON",
      "hi": "अमान्य JSON",
      "ja": "無効なJSON",
      "ko": "잘못된 JSON"
    },
    "invalidYaml": {
      "zh-TW": "無效的 YAML",
      "zh-CN": "无效的 YAML",
      "en": "Invalid YAML",
      "hi": "अमान्य YAML",
      "ja": "無効なYAML",
      "ko": "잘못된 YAML"
    },
    "indentation": {
      "zh-TW": "縮排空格",
      "zh-CN": "缩进空格",
      "en": "Indentation",
      "hi": "इंडेंटेशन",
      "ja": "インデント",
      "ko": "들여쓰기"
    },
    "spaces": {
      "zh-TW": "空格",
      "zh-CN": "空格",
      "en": "spaces",
      "hi": "स्पेस",
      "ja": "スペース",
      "ko": "스페이스"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "雙向轉換",
      "zh-CN": "双向转换",
      "en": "Bidirectional",
      "hi": "द्विदिशीय",
      "ja": "双方向",
      "ko": "양방향"
    },
    "feature1Description": {
      "zh-TW": "支援 JSON 和 YAML 雙向轉換",
      "zh-CN": "支持 JSON 和 YAML 双向转换",
      "en": "Convert between JSON and YAML in both directions",
      "hi": "दोनों दिशाओं में JSON और YAML के बीच रूपांतरण करें",
      "ja": "JSONとYAMLを双方向に変換",
      "ko": "JSON과 YAML 양방향 변환"
    },
    "feature2Title": {
      "zh-TW": "格式化輸出",
      "zh-CN": "格式化输出",
      "en": "Formatted Output",
      "hi": "फॉर्मेटेड आउटपुट",
      "ja": "フォーマット出力",
      "ko": "포맷된 출력"
    },
    "feature2Description": {
      "zh-TW": "自動格式化和美化輸出",
      "zh-CN": "自动格式化和美化输出",
      "en": "Auto-format and beautify output",
      "hi": "ऑटो-फॉर्मेट और सुंदर आउटपुट",
      "ja": "自動フォーマットと出力の美化",
      "ko": "자동 포맷 및 출력 미화"
    },
    "feature3Title": {
      "zh-TW": "語法高亮",
      "zh-CN": "语法高亮",
      "en": "Syntax Highlighting",
      "hi": "सिंटैक्स हाइलाइटिंग",
      "ja": "構文ハイライト",
      "ko": "구문 강조"
    },
    "feature3Description": {
      "zh-TW": "清晰的語法高亮顯示",
      "zh-CN": "清晰的语法高亮显示",
      "en": "Clear syntax highlighting for better readability",
      "hi": "बेहतर पठनीयता के लिए स्पष्ट सिंटैक्स हाइलाइटिंग",
      "ja": "読みやすさのための明確な構文ハイライト",
      "ko": "가독성을 위한 명확한 구문 강조"
    },
    "feature4Title": {
      "zh-TW": "錯誤檢測",
      "zh-CN": "错误检测",
      "en": "Error Detection",
      "hi": "त्रुटि का पता लगाना",
      "ja": "エラー検出",
      "ko": "오류 감지"
    },
    "feature4Description": {
      "zh-TW": "即時錯誤檢測和提示",
      "zh-CN": "即时错误检测和提示",
      "en": "Real-time error detection and hints",
      "hi": "रीयल-टाइम त्रुटि का पता लगाना और संकेत",
      "ja": "リアルタイムのエラー検出とヒント",
      "ko": "실시간 오류 감지 및 힌트"
    },
    "jsonIndent": {
      "zh-TW": "JSON 縮排",
      "zh-CN": "JSON 缩进",
      "en": "JSON Indent",
      "hi": "JSON इंडेंट",
      "ja": "JSONインデント",
      "ko": "JSON 들여쓰기"
    },
    "yamlIndent": {
      "zh-TW": "YAML 縮排",
      "zh-CN": "YAML 缩进",
      "en": "YAML Indent",
      "hi": "YAML इंडेंट",
      "ja": "YAMLインデント",
      "ko": "YAML 들여쓰기"
    },
    "noIndent": {
      "zh-TW": "無縮排",
      "zh-CN": "无缩进",
      "en": "No Indent",
      "hi": "कोई इंडेंट नहीं",
      "ja": "インデントなし",
      "ko": "들여쓰기 없음"
    },
    "options": {
      "zh-TW": "選項",
      "zh-CN": "选项",
      "en": "Options",
      "hi": "विकल्प",
      "ja": "オプション",
      "ko": "옵션"
    },
    "sortKeys": {
      "zh-TW": "排序鍵",
      "zh-CN": "排序键",
      "en": "Sort Keys",
      "hi": "कुंजियाँ क्रमबद्ध करें",
      "ja": "キーをソート",
      "ko": "키 정렬"
    },
    "sortKeysDesc": {
      "zh-TW": "按字母順序排序鍵",
      "zh-CN": "按字母顺序排序键",
      "en": "Sort keys alphabetically",
      "hi": "कुंजियों को वर्णानुक्रम में क्रमबद्ध करें",
      "ja": "キーをアルファベット順にソート",
      "ko": "키를 알파벳순으로 정렬"
    },
    "outputPlaceholder": {
      "zh-TW": "轉換結果將顯示在這裡...",
      "zh-CN": "转换结果将显示在这里...",
      "en": "Conversion result will appear here...",
      "hi": "रूपांतरण परिणाम यहाँ दिखाई देगा...",
      "ja": "変換結果がここに表示されます...",
      "ko": "변환 결과가 여기에 표시됩니다..."
    }
  },

  // IP 地址工具
  "ipAddressTool": {
    "title": {
      "zh-TW": "IP 地址工具",
      "zh-CN": "IP 地址工具",
      "en": "IP Address Tool",
      "hi": "IP एड्रेस टूल",
      "ja": "IPアドレスツール",
      "ko": "IP 주소 도구"
    },
    "description": {
      "zh-TW": "IP 地址驗證、CIDR 計算、子網遮罩轉換",
      "zh-CN": "IP 地址验证、CIDR 计算、子网掩码转换",
      "en": "IP address validation, CIDR calculation, subnet mask conversion",
      "hi": "IP पता सत्यापन, CIDR गणना, सबनेट मास्क रूपांतरण",
      "ja": "IPアドレス検証、CIDR計算、サブネットマスク変換",
      "ko": "IP 주소 검증, CIDR 계산, 서브넷 마스크 변환"
    },
    "ipAddress": {
      "zh-TW": "IP 地址",
      "zh-CN": "IP 地址",
      "en": "IP Address",
      "hi": "IP पता",
      "ja": "IPアドレス",
      "ko": "IP 주소"
    },
    "ipPlaceholder": {
      "zh-TW": "輸入 IPv4 或 IPv6 地址",
      "zh-CN": "输入 IPv4 或 IPv6 地址",
      "en": "Enter IPv4 or IPv6 address",
      "hi": "IPv4 या IPv6 पता दर्ज करें",
      "ja": "IPv4またはIPv6アドレスを入力",
      "ko": "IPv4 또는 IPv6 주소 입력"
    },
    "validate": {
      "zh-TW": "驗證",
      "zh-CN": "验证",
      "en": "Validate",
      "hi": "मान्य करें",
      "ja": "検証",
      "ko": "검증"
    },
    "validIpv4": {
      "zh-TW": "有效的 IPv4 地址",
      "zh-CN": "有效的 IPv4 地址",
      "en": "Valid IPv4 address",
      "hi": "मान्य IPv4 पता",
      "ja": "有効なIPv4アドレス",
      "ko": "유효한 IPv4 주소"
    },
    "validIpv6": {
      "zh-TW": "有效的 IPv6 地址",
      "zh-CN": "有效的 IPv6 地址",
      "en": "Valid IPv6 address",
      "hi": "मान्य IPv6 पता",
      "ja": "有効なIPv6アドレス",
      "ko": "유효한 IPv6 주소"
    },
    "invalidIp": {
      "zh-TW": "無效的 IP 地址",
      "zh-CN": "无效的 IP 地址",
      "en": "Invalid IP address",
      "hi": "अमान्य IP पता",
      "ja": "無効なIPアドレス",
      "ko": "잘못된 IP 주소"
    },
    "cidrCalculator": {
      "zh-TW": "CIDR 計算器",
      "zh-CN": "CIDR 计算器",
      "en": "CIDR Calculator",
      "hi": "CIDR कैलकुलेटर",
      "ja": "CIDR計算機",
      "ko": "CIDR 계산기"
    },
    "cidrNotation": {
      "zh-TW": "CIDR 表示法",
      "zh-CN": "CIDR 表示法",
      "en": "CIDR Notation",
      "hi": "CIDR नोटेशन",
      "ja": "CIDR表記",
      "ko": "CIDR 표기법"
    },
    "cidrPlaceholder": {
      "zh-TW": "例如：192.168.1.0/24",
      "zh-CN": "例如：192.168.1.0/24",
      "en": "e.g., 192.168.1.0/24",
      "hi": "जैसे: 192.168.1.0/24",
      "ja": "例: 192.168.1.0/24",
      "ko": "예: 192.168.1.0/24"
    },
    "networkAddress": {
      "zh-TW": "網路地址",
      "zh-CN": "网络地址",
      "en": "Network Address",
      "hi": "नेटवर्क पता",
      "ja": "ネットワークアドレス",
      "ko": "네트워크 주소"
    },
    "broadcastAddress": {
      "zh-TW": "廣播地址",
      "zh-CN": "广播地址",
      "en": "Broadcast Address",
      "hi": "ब्रॉडकास्ट पता",
      "ja": "ブロードキャストアドレス",
      "ko": "브로드캐스트 주소"
    },
    "subnetMask": {
      "zh-TW": "子網遮罩",
      "zh-CN": "子网掩码",
      "en": "Subnet Mask",
      "hi": "सबनेट मास्क",
      "ja": "サブネットマスク",
      "ko": "서브넷 마스크"
    },
    "wildcardMask": {
      "zh-TW": "萬用字元遮罩",
      "zh-CN": "通配符掩码",
      "en": "Wildcard Mask",
      "hi": "वाइल्डकार्ड मास्क",
      "ja": "ワイルドカードマスク",
      "ko": "와일드카드 마스크"
    },
    "hostRange": {
      "zh-TW": "主機範圍",
      "zh-CN": "主机范围",
      "en": "Host Range",
      "hi": "होस्ट रेंज",
      "ja": "ホスト範囲",
      "ko": "호스트 범위"
    },
    "totalHosts": {
      "zh-TW": "可用主機數",
      "zh-CN": "可用主机数",
      "en": "Total Hosts",
      "hi": "कुल होस्ट",
      "ja": "ホスト総数",
      "ko": "총 호스트 수"
    },
    "ipRangeChecker": {
      "zh-TW": "IP 範圍檢查",
      "zh-CN": "IP 范围检查",
      "en": "IP Range Checker",
      "hi": "IP रेंज चेकर",
      "ja": "IP範囲チェッカー",
      "ko": "IP 범위 확인"
    },
    "checkIp": {
      "zh-TW": "檢查 IP",
      "zh-CN": "检查 IP",
      "en": "Check IP",
      "hi": "IP जांचें",
      "ja": "IPをチェック",
      "ko": "IP 확인"
    },
    "ipInRange": {
      "zh-TW": "IP 在範圍內",
      "zh-CN": "IP 在范围内",
      "en": "IP is in range",
      "hi": "IP रेंज में है",
      "ja": "IPは範囲内です",
      "ko": "IP가 범위 내에 있음"
    },
    "ipNotInRange": {
      "zh-TW": "IP 不在範圍內",
      "zh-CN": "IP 不在范围内",
      "en": "IP is not in range",
      "hi": "IP रेंज में नहीं है",
      "ja": "IPは範囲外です",
      "ko": "IP가 범위 내에 없음"
    },
    "ipv4ToIpv6": {
      "zh-TW": "IPv4 轉 IPv6",
      "zh-CN": "IPv4 转 IPv6",
      "en": "IPv4 to IPv6",
      "hi": "IPv4 से IPv6",
      "ja": "IPv4からIPv6",
      "ko": "IPv4에서 IPv6"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "IP 驗證",
      "zh-CN": "IP 验证",
      "en": "IP Validation",
      "hi": "IP सत्यापन",
      "ja": "IP検証",
      "ko": "IP 검증"
    },
    "feature1Description": {
      "zh-TW": "支援 IPv4 和 IPv6 地址驗證",
      "zh-CN": "支持 IPv4 和 IPv6 地址验证",
      "en": "Supports IPv4 and IPv6 address validation",
      "hi": "IPv4 और IPv6 पता सत्यापन का समर्थन",
      "ja": "IPv4とIPv6アドレスの検証をサポート",
      "ko": "IPv4 및 IPv6 주소 검증 지원"
    },
    "feature2Title": {
      "zh-TW": "CIDR 計算",
      "zh-CN": "CIDR 计算",
      "en": "CIDR Calculation",
      "hi": "CIDR गणना",
      "ja": "CIDR計算",
      "ko": "CIDR 계산"
    },
    "feature2Description": {
      "zh-TW": "計算網路地址、廣播地址和主機範圍",
      "zh-CN": "计算网络地址、广播地址和主机范围",
      "en": "Calculate network address, broadcast address, and host range",
      "hi": "नेटवर्क पता, ब्रॉडकास्ट पता और होस्ट रेंज की गणना करें",
      "ja": "ネットワークアドレス、ブロードキャストアドレス、ホスト範囲を計算",
      "ko": "네트워크 주소, 브로드캐스트 주소 및 호스트 범위 계산"
    },
    "binary": {
      "zh-TW": "二進位",
      "zh-CN": "二进制",
      "en": "Binary",
      "hi": "बाइनरी",
      "ja": "2進数",
      "ko": "2진수"
    },
    "decimal": {
      "zh-TW": "十進位",
      "zh-CN": "十进制",
      "en": "Decimal",
      "hi": "दशमलव",
      "ja": "10進数",
      "ko": "10진수"
    },
    "cidrPrefix": {
      "zh-TW": "CIDR 前綴",
      "zh-CN": "CIDR 前缀",
      "en": "CIDR Prefix",
      "hi": "CIDR प्रीफ़िक्स",
      "ja": "CIDRプレフィックス",
      "ko": "CIDR 접두사"
    },
    "class": {
      "zh-TW": "類別",
      "zh-CN": "类别",
      "en": "Class",
      "hi": "क्लास",
      "ja": "クラス",
      "ko": "클래스"
    },
    "enterIp": {
      "zh-TW": "輸入 IP 地址",
      "zh-CN": "输入 IP 地址",
      "en": "Enter IP address",
      "hi": "IP पता दर्ज करें",
      "ja": "IPアドレスを入力",
      "ko": "IP 주소 입력"
    },
    "firstHost": {
      "zh-TW": "第一個主機",
      "zh-CN": "第一个主机",
      "en": "First Host",
      "hi": "पहला होस्ट",
      "ja": "最初のホスト",
      "ko": "첫 번째 호스트"
    },
    "lastHost": {
      "zh-TW": "最後一個主機",
      "zh-CN": "最后一个主机",
      "en": "Last Host",
      "hi": "अंतिम होस्ट",
      "ja": "最後のホスト",
      "ko": "마지막 호스트"
    },
    "inRange": {
      "zh-TW": "在範圍內",
      "zh-CN": "在范围内",
      "en": "In Range",
      "hi": "रेंज में",
      "ja": "範囲内",
      "ko": "범위 내"
    },
    "notInRange": {
      "zh-TW": "不在範圍內",
      "zh-CN": "不在范围内",
      "en": "Not In Range",
      "hi": "रेंज में नहीं",
      "ja": "範囲外",
      "ko": "범위 외"
    },
    "ipConversion": {
      "zh-TW": "IP 轉換",
      "zh-CN": "IP 转换",
      "en": "IP Conversion",
      "hi": "IP रूपांतरण",
      "ja": "IP変換",
      "ko": "IP 변환"
    },
    "ipValidation": {
      "zh-TW": "IP 驗證",
      "zh-CN": "IP 验证",
      "en": "IP Validation",
      "hi": "IP सत्यापन",
      "ja": "IP検証",
      "ko": "IP 검증"
    },
    "ipv6Compatible": {
      "zh-TW": "IPv6 兼容格式",
      "zh-CN": "IPv6 兼容格式",
      "en": "IPv6 Compatible",
      "hi": "IPv6 संगत",
      "ja": "IPv6互換",
      "ko": "IPv6 호환"
    },
    "ipv6Full": {
      "zh-TW": "IPv6 完整格式",
      "zh-CN": "IPv6 完整格式",
      "en": "IPv6 Full Format",
      "hi": "IPv6 पूर्ण प्रारूप",
      "ja": "IPv6完全形式",
      "ko": "IPv6 전체 형식"
    },
    "ipv6Mapped": {
      "zh-TW": "IPv6 映射格式",
      "zh-CN": "IPv6 映射格式",
      "en": "IPv6 Mapped",
      "hi": "IPv6 मैप्ड",
      "ja": "IPv6マップド",
      "ko": "IPv6 매핑"
    },
    "isValid": {
      "zh-TW": "有效",
      "zh-CN": "有效",
      "en": "Valid",
      "hi": "मान्य",
      "ja": "有効",
      "ko": "유효"
    },
    "privateRanges": {
      "zh-TW": "私有範圍",
      "zh-CN": "私有范围",
      "en": "Private Ranges",
      "hi": "निजी रेंज",
      "ja": "プライベート範囲",
      "ko": "사설 범위"
    },
    "rangeChecker": {
      "zh-TW": "範圍檢查",
      "zh-CN": "范围检查",
      "en": "Range Checker",
      "hi": "रेंज चेकर",
      "ja": "範囲チェッカー",
      "ko": "범위 확인"
    },
    "rangeStart": {
      "zh-TW": "起始 IP",
      "zh-CN": "起始 IP",
      "en": "Range Start",
      "hi": "रेंज शुरू",
      "ja": "範囲開始",
      "ko": "범위 시작"
    },
    "rangeEnd": {
      "zh-TW": "結束 IP",
      "zh-CN": "结束 IP",
      "en": "Range End",
      "hi": "रेंज समाप्त",
      "ja": "範囲終了",
      "ko": "범위 끝"
    },
    "type": {
      "zh-TW": "類型",
      "zh-CN": "类型",
      "en": "Type",
      "hi": "प्रकार",
      "ja": "タイプ",
      "ko": "유형"
    },
    "usableHosts": {
      "zh-TW": "可用主機",
      "zh-CN": "可用主机",
      "en": "Usable Hosts",
      "hi": "उपयोग योग्य होस्ट",
      "ja": "使用可能ホスト",
      "ko": "사용 가능 호스트"
    },
    "version": {
      "zh-TW": "版本",
      "zh-CN": "版本",
      "en": "Version",
      "hi": "संस्करण",
      "ja": "バージョン",
      "ko": "버전"
    }
  },

  // HTML 實體編碼器
  "htmlEntityEncoder": {
    "title": {
      "zh-TW": "HTML 實體編碼器",
      "zh-CN": "HTML 实体编码器",
      "en": "HTML Entity Encoder",
      "hi": "HTML एंटिटी एनकोडर",
      "ja": "HTMLエンティティエンコーダー",
      "ko": "HTML 엔티티 인코더"
    },
    "description": {
      "zh-TW": "編碼和解碼 HTML 實體，支援命名、十進位和十六進位格式",
      "zh-CN": "编码和解码 HTML 实体，支持命名、十进制和十六进制格式",
      "en": "Encode and decode HTML entities with named, decimal, and hex formats",
      "hi": "नामित, दशमलव और हेक्स प्रारूपों के साथ HTML एंटिटी एनकोड और डीकोड करें",
      "ja": "名前付き、10進数、16進数形式でHTMLエンティティをエンコード・デコード",
      "ko": "이름, 10진수, 16진수 형식으로 HTML 엔티티 인코딩 및 디코딩"
    },
    "encode": {
      "zh-TW": "編碼",
      "zh-CN": "编码",
      "en": "Encode",
      "hi": "एनकोड",
      "ja": "エンコード",
      "ko": "인코딩"
    },
    "decode": {
      "zh-TW": "解碼",
      "zh-CN": "解码",
      "en": "Decode",
      "hi": "डीकोड",
      "ja": "デコード",
      "ko": "디코딩"
    },
    "inputText": {
      "zh-TW": "輸入文字",
      "zh-CN": "输入文字",
      "en": "Input Text",
      "hi": "इनपुट टेक्स्ट",
      "ja": "入力テキスト",
      "ko": "입력 텍스트"
    },
    "outputText": {
      "zh-TW": "輸出結果",
      "zh-CN": "输出结果",
      "en": "Output Result",
      "hi": "आउटपुट परिणाम",
      "ja": "出力結果",
      "ko": "출력 결과"
    },
    "encodePlaceholder": {
      "zh-TW": "輸入要編碼的文字...",
      "zh-CN": "输入要编码的文字...",
      "en": "Enter text to encode...",
      "hi": "एनकोड करने के लिए टेक्स्ट दर्ज करें...",
      "ja": "エンコードするテキストを入力...",
      "ko": "인코딩할 텍스트 입력..."
    },
    "decodePlaceholder": {
      "zh-TW": "輸入要解碼的 HTML 實體...",
      "zh-CN": "输入要解码的 HTML 实体...",
      "en": "Enter HTML entities to decode...",
      "hi": "डीकोड करने के लिए HTML एंटिटी दर्ज करें...",
      "ja": "デコードするHTMLエンティティを入力...",
      "ko": "디코딩할 HTML 엔티티 입력..."
    },
    "format": {
      "zh-TW": "編碼格式",
      "zh-CN": "编码格式",
      "en": "Encoding Format",
      "hi": "एनकोडिंग प्रारूप",
      "ja": "エンコード形式",
      "ko": "인코딩 형식"
    },
    "named": {
      "zh-TW": "命名實體",
      "zh-CN": "命名实体",
      "en": "Named",
      "hi": "नामित",
      "ja": "名前付き",
      "ko": "명명된"
    },
    "decimal": {
      "zh-TW": "十進位",
      "zh-CN": "十进制",
      "en": "Decimal",
      "hi": "दशमलव",
      "ja": "10進数",
      "ko": "10진수"
    },
    "hexadecimal": {
      "zh-TW": "十六進位",
      "zh-CN": "十六进制",
      "en": "Hexadecimal",
      "hi": "हेक्साडेसिमल",
      "ja": "16進数",
      "ko": "16진수"
    },
    "encodeAll": {
      "zh-TW": "編碼所有字元",
      "zh-CN": "编码所有字符",
      "en": "Encode All Characters",
      "hi": "सभी वर्ण एनकोड करें",
      "ja": "すべての文字をエンコード",
      "ko": "모든 문자 인코딩"
    },
    "commonEntities": {
      "zh-TW": "常用 HTML 實體",
      "zh-CN": "常用 HTML 实体",
      "en": "Common HTML Entities",
      "hi": "सामान्य HTML एंटिटी",
      "ja": "よく使うHTMLエンティティ",
      "ko": "일반 HTML 엔티티"
    },
    "character": {
      "zh-TW": "字元",
      "zh-CN": "字符",
      "en": "Character",
      "hi": "वर्ण",
      "ja": "文字",
      "ko": "문자"
    },
    "entity": {
      "zh-TW": "實體",
      "zh-CN": "实体",
      "en": "Entity",
      "hi": "एंटिटी",
      "ja": "エンティティ",
      "ko": "엔티티"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "多種格式",
      "zh-CN": "多种格式",
      "en": "Multiple Formats",
      "hi": "कई प्रारूप",
      "ja": "複数形式",
      "ko": "다양한 형식"
    },
    "feature1Description": {
      "zh-TW": "支援命名、十進位和十六進位實體",
      "zh-CN": "支持命名、十进制和十六进制实体",
      "en": "Support named, decimal, and hex entities",
      "hi": "नामित, दशमलव और हेक्स एंटिटी का समर्थन",
      "ja": "名前付き、10進数、16進数エンティティをサポート",
      "ko": "명명된, 10진수, 16진수 엔티티 지원"
    },
    "feature2Title": {
      "zh-TW": "雙向轉換",
      "zh-CN": "双向转换",
      "en": "Two-way Conversion",
      "hi": "दो-तरफा रूपांतरण",
      "ja": "双方向変換",
      "ko": "양방향 변환"
    },
    "feature2Description": {
      "zh-TW": "支援編碼和解碼雙向操作",
      "zh-CN": "支持编码和解码双向操作",
      "en": "Support both encoding and decoding",
      "hi": "एनकोडिंग और डीकोडिंग दोनों का समर्थन",
      "ja": "エンコードとデコードの両方をサポート",
      "ko": "인코딩과 디코딩 모두 지원"
    },
    "allNonAscii": {
      "zh-TW": "所有非 ASCII 字元",
      "zh-CN": "所有非 ASCII 字符",
      "en": "All Non-ASCII",
      "hi": "सभी गैर-ASCII",
      "ja": "すべての非ASCII",
      "ko": "모든 비-ASCII"
    },
    "decimalEntities": {
      "zh-TW": "十進位實體",
      "zh-CN": "十进制实体",
      "en": "Decimal Entities",
      "hi": "दशमलव एंटिटी",
      "ja": "10進数エンティティ",
      "ko": "10진수 엔티티"
    },
    "encodingType": {
      "zh-TW": "編碼類型",
      "zh-CN": "编码类型",
      "en": "Encoding Type",
      "hi": "एनकोडिंग प्रकार",
      "ja": "エンコードタイプ",
      "ko": "인코딩 유형"
    },
    "hex": {
      "zh-TW": "十六進位",
      "zh-CN": "十六进制",
      "en": "Hex",
      "hi": "हेक्स",
      "ja": "16進数",
      "ko": "16진수"
    },
    "hexEntities": {
      "zh-TW": "十六進位實體",
      "zh-CN": "十六进制实体",
      "en": "Hex Entities",
      "hi": "हेक्स एंटिटी",
      "ja": "16進数エンティティ",
      "ko": "16진수 엔티티"
    },
    "namedEntities": {
      "zh-TW": "命名實體",
      "zh-CN": "命名实体",
      "en": "Named Entities",
      "hi": "नामित एंटिटी",
      "ja": "名前付きエンティティ",
      "ko": "명명된 엔티티"
    },
    "options": {
      "zh-TW": "選項",
      "zh-CN": "选项",
      "en": "Options",
      "hi": "विकल्प",
      "ja": "オプション",
      "ko": "옵션"
    },
    "scope": {
      "zh-TW": "編碼範圍",
      "zh-CN": "编码范围",
      "en": "Scope",
      "hi": "दायरा",
      "ja": "スコープ",
      "ko": "범위"
    },
    "specialOnly": {
      "zh-TW": "僅特殊字元",
      "zh-CN": "仅特殊字符",
      "en": "Special Only",
      "hi": "केवल विशेष",
      "ja": "特殊文字のみ",
      "ko": "특수 문자만"
    }
  },

  // 色彩轉換器
  "colorConverter": {
    "title": {
      "zh-TW": "色彩轉換器",
      "zh-CN": "颜色转换器",
      "en": "Color Converter",
      "hi": "रंग कनवर्टर",
      "ja": "カラー変換",
      "ko": "색상 변환기"
    },
    "description": {
      "zh-TW": "在 HEX、RGB、HSL、CMYK 等色彩格式之間轉換",
      "zh-CN": "在 HEX、RGB、HSL、CMYK 等颜色格式之间转换",
      "en": "Convert between HEX, RGB, HSL, CMYK and other color formats",
      "hi": "HEX, RGB, HSL, CMYK और अन्य रंग प्रारूपों के बीच रूपांतरण करें",
      "ja": "HEX、RGB、HSL、CMYKなどのカラーフォーマット間で変換",
      "ko": "HEX, RGB, HSL, CMYK 등 색상 형식 간 변환"
    },
    "colorPicker": {
      "zh-TW": "色彩選擇器",
      "zh-CN": "颜色选择器",
      "en": "Color Picker",
      "hi": "रंग चयनकर्ता",
      "ja": "カラーピッカー",
      "ko": "색상 선택기"
    },
    "hexValue": {
      "zh-TW": "HEX 值",
      "zh-CN": "HEX 值",
      "en": "HEX Value",
      "hi": "HEX मान",
      "ja": "HEX値",
      "ko": "HEX 값"
    },
    "rgbValue": {
      "zh-TW": "RGB 值",
      "zh-CN": "RGB 值",
      "en": "RGB Value",
      "hi": "RGB मान",
      "ja": "RGB値",
      "ko": "RGB 값"
    },
    "hslValue": {
      "zh-TW": "HSL 值",
      "zh-CN": "HSL 值",
      "en": "HSL Value",
      "hi": "HSL मान",
      "ja": "HSL値",
      "ko": "HSL 값"
    },
    "cmykValue": {
      "zh-TW": "CMYK 值",
      "zh-CN": "CMYK 值",
      "en": "CMYK Value",
      "hi": "CMYK मान",
      "ja": "CMYK値",
      "ko": "CMYK 값"
    },
    "preview": {
      "zh-TW": "預覽",
      "zh-CN": "预览",
      "en": "Preview",
      "hi": "पूर्वावलोकन",
      "ja": "プレビュー",
      "ko": "미리보기"
    },
    "colorHarmony": {
      "zh-TW": "色彩調和",
      "zh-CN": "颜色调和",
      "en": "Color Harmony",
      "hi": "रंग सामंजस्य",
      "ja": "カラーハーモニー",
      "ko": "색상 조화"
    },
    "complementary": {
      "zh-TW": "互補色",
      "zh-CN": "互补色",
      "en": "Complementary",
      "hi": "पूरक",
      "ja": "補色",
      "ko": "보색"
    },
    "analogous": {
      "zh-TW": "相似色",
      "zh-CN": "相似色",
      "en": "Analogous",
      "hi": "अनुरूप",
      "ja": "類似色",
      "ko": "유사색"
    },
    "triadic": {
      "zh-TW": "三角色",
      "zh-CN": "三角色",
      "en": "Triadic",
      "hi": "त्रिभुज",
      "ja": "トライアド",
      "ko": "삼원색"
    },
    "tetradic": {
      "zh-TW": "四角色",
      "zh-CN": "四角色",
      "en": "Tetradic",
      "hi": "टेट्राडिक",
      "ja": "テトラード",
      "ko": "사원색"
    },
    "splitComplementary": {
      "zh-TW": "分裂互補色",
      "zh-CN": "分裂互补色",
      "en": "Split Complementary",
      "hi": "स्प्लिट कॉम्प्लिमेंट्री",
      "ja": "スプリット補色",
      "ko": "분할 보색"
    },
    "shades": {
      "zh-TW": "色調變化",
      "zh-CN": "色调变化",
      "en": "Shades",
      "hi": "शेड्स",
      "ja": "シェード",
      "ko": "색조"
    },
    "tints": {
      "zh-TW": "色彩淡化",
      "zh-CN": "颜色淡化",
      "en": "Tints",
      "hi": "टिंट्स",
      "ja": "ティント",
      "ko": "틴트"
    },
    "recentColors": {
      "zh-TW": "最近使用",
      "zh-CN": "最近使用",
      "en": "Recent Colors",
      "hi": "हाल के रंग",
      "ja": "最近使用した色",
      "ko": "최근 색상"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "多格式支援",
      "zh-CN": "多格式支持",
      "en": "Multi-format Support",
      "hi": "बहु-प्रारूप समर्थन",
      "ja": "マルチフォーマット対応",
      "ko": "다중 형식 지원"
    },
    "feature1Description": {
      "zh-TW": "支援 HEX、RGB、HSL、CMYK 格式",
      "zh-CN": "支持 HEX、RGB、HSL、CMYK 格式",
      "en": "Supports HEX, RGB, HSL, CMYK formats",
      "hi": "HEX, RGB, HSL, CMYK प्रारूपों का समर्थन",
      "ja": "HEX、RGB、HSL、CMYK形式をサポート",
      "ko": "HEX, RGB, HSL, CMYK 형식 지원"
    },
    "feature2Title": {
      "zh-TW": "色彩調和",
      "zh-CN": "颜色调和",
      "en": "Color Harmony",
      "hi": "रंग सामंजस्य",
      "ja": "カラーハーモニー",
      "ko": "색상 조화"
    },
    "feature2Description": {
      "zh-TW": "自動計算互補色、相似色等",
      "zh-CN": "自动计算互补色、相似色等",
      "en": "Auto calculate complementary, analogous colors",
      "hi": "पूरक, अनुरूप रंगों की स्वचालित गणना",
      "ja": "補色、類似色などを自動計算",
      "ko": "보색, 유사색 등 자동 계산"
    },
    "clickToSelect": {
      "zh-TW": "點擊選擇顏色",
      "zh-CN": "点击选择颜色",
      "en": "Click to select color",
      "hi": "रंग चुनने के लिए क्लिक करें",
      "ja": "クリックして色を選択",
      "ko": "클릭하여 색상 선택"
    },
    "harmony": {
      "zh-TW": "調和色",
      "zh-CN": "调和色",
      "en": "Harmony",
      "hi": "सामंजस्य",
      "ja": "ハーモニー",
      "ko": "조화"
    },
    "hue": {
      "zh-TW": "色相",
      "zh-CN": "色相",
      "en": "Hue",
      "hi": "रंग",
      "ja": "色相",
      "ko": "색상"
    },
    "lightness": {
      "zh-TW": "亮度",
      "zh-CN": "亮度",
      "en": "Lightness",
      "hi": "हल्कापन",
      "ja": "明度",
      "ko": "밝기"
    },
    "palette": {
      "zh-TW": "調色盤",
      "zh-CN": "调色板",
      "en": "Palette",
      "hi": "पैलेट",
      "ja": "パレット",
      "ko": "팔레트"
    },
    "saturation": {
      "zh-TW": "飽和度",
      "zh-CN": "饱和度",
      "en": "Saturation",
      "hi": "संतृप्ति",
      "ja": "彩度",
      "ko": "채도"
    },
    "sliders": {
      "zh-TW": "滑桿",
      "zh-CN": "滑块",
      "en": "Sliders",
      "hi": "स्लाइडर",
      "ja": "スライダー",
      "ko": "슬라이더"
    }
  },

  // Lorem Ipsum 生成器
  "loremIpsumGenerator": {
    "title": {
      "zh-TW": "Lorem Ipsum 生成器",
      "zh-CN": "Lorem Ipsum 生成器",
      "en": "Lorem Ipsum Generator",
      "hi": "Lorem Ipsum जेनरेटर",
      "ja": "Lorem Ipsumジェネレーター",
      "ko": "Lorem Ipsum 생성기"
    },
    "description": {
      "zh-TW": "生成佔位文字和假資料，適用於設計和開發測試",
      "zh-CN": "生成占位文字和假数据，适用于设计和开发测试",
      "en": "Generate placeholder text and fake data for design and development testing",
      "hi": "डिजाइन और विकास परीक्षण के लिए प्लेसहोल्डर टेक्स्ट और नकली डेटा जेनरेट करें",
      "ja": "デザインや開発テスト用のプレースホルダーテキストとフェイクデータを生成",
      "ko": "디자인 및 개발 테스트용 플레이스홀더 텍스트 및 가짜 데이터 생성"
    },
    "textGenerator": {
      "zh-TW": "文字生成器",
      "zh-CN": "文字生成器",
      "en": "Text Generator",
      "hi": "टेक्स्ट जेनरेटर",
      "ja": "テキストジェネレーター",
      "ko": "텍스트 생성기"
    },
    "type": {
      "zh-TW": "類型",
      "zh-CN": "类型",
      "en": "Type",
      "hi": "प्रकार",
      "ja": "タイプ",
      "ko": "유형"
    },
    "paragraphs": {
      "zh-TW": "段落",
      "zh-CN": "段落",
      "en": "Paragraphs",
      "hi": "पैराग्राफ",
      "ja": "段落",
      "ko": "단락"
    },
    "sentences": {
      "zh-TW": "句子",
      "zh-CN": "句子",
      "en": "Sentences",
      "hi": "वाक्य",
      "ja": "文",
      "ko": "문장"
    },
    "words": {
      "zh-TW": "單詞",
      "zh-CN": "单词",
      "en": "Words",
      "hi": "शब्द",
      "ja": "単語",
      "ko": "단어"
    },
    "count": {
      "zh-TW": "數量",
      "zh-CN": "数量",
      "en": "Count",
      "hi": "गिनती",
      "ja": "数量",
      "ko": "개수"
    },
    "style": {
      "zh-TW": "風格",
      "zh-CN": "风格",
      "en": "Style",
      "hi": "शैली",
      "ja": "スタイル",
      "ko": "스타일"
    },
    "classic": {
      "zh-TW": "經典拉丁文",
      "zh-CN": "经典拉丁文",
      "en": "Classic Latin",
      "hi": "क्लासिक लैटिन",
      "ja": "クラシックラテン語",
      "ko": "클래식 라틴어"
    },
    "hipster": {
      "zh-TW": "時尚文青風",
      "zh-CN": "时尚文青风",
      "en": "Hipster",
      "hi": "हिप्स्टर",
      "ja": "ヒップスター",
      "ko": "힙스터"
    },
    "office": {
      "zh-TW": "辦公室用語",
      "zh-CN": "办公室用语",
      "en": "Office",
      "hi": "ऑफिस",
      "ja": "オフィス",
      "ko": "오피스"
    },
    "generate": {
      "zh-TW": "生成",
      "zh-CN": "生成",
      "en": "Generate",
      "hi": "जेनरेट",
      "ja": "生成",
      "ko": "생성"
    },
    "generatedText": {
      "zh-TW": "生成的文字",
      "zh-CN": "生成的文字",
      "en": "Generated Text",
      "hi": "जेनरेट किया गया टेक्स्ट",
      "ja": "生成されたテキスト",
      "ko": "생성된 텍스트"
    },
    "fakeDataGenerator": {
      "zh-TW": "假資料生成器",
      "zh-CN": "假数据生成器",
      "en": "Fake Data Generator",
      "hi": "नकली डेटा जेनरेटर",
      "ja": "フェイクデータジェネレーター",
      "ko": "가짜 데이터 생성기"
    },
    "dataType": {
      "zh-TW": "資料類型",
      "zh-CN": "数据类型",
      "en": "Data Type",
      "hi": "डेटा प्रकार",
      "ja": "データタイプ",
      "ko": "데이터 유형"
    },
    "name": {
      "zh-TW": "姓名",
      "zh-CN": "姓名",
      "en": "Name",
      "hi": "नाम",
      "ja": "名前",
      "ko": "이름"
    },
    "email": {
      "zh-TW": "電子郵件",
      "zh-CN": "电子邮件",
      "en": "Email",
      "hi": "ईमेल",
      "ja": "メール",
      "ko": "이메일"
    },
    "phone": {
      "zh-TW": "電話號碼",
      "zh-CN": "电话号码",
      "en": "Phone",
      "hi": "फोन",
      "ja": "電話番号",
      "ko": "전화번호"
    },
    "address": {
      "zh-TW": "地址",
      "zh-CN": "地址",
      "en": "Address",
      "hi": "पता",
      "ja": "住所",
      "ko": "주소"
    },
    "company": {
      "zh-TW": "公司名稱",
      "zh-CN": "公司名称",
      "en": "Company",
      "hi": "कंपनी",
      "ja": "会社名",
      "ko": "회사명"
    },
    "uuid": {
      "zh-TW": "UUID",
      "zh-CN": "UUID",
      "en": "UUID",
      "hi": "UUID",
      "ja": "UUID",
      "ko": "UUID"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "多種風格",
      "zh-CN": "多种风格",
      "en": "Multiple Styles",
      "hi": "कई शैलियां",
      "ja": "複数スタイル",
      "ko": "다양한 스타일"
    },
    "feature1Description": {
      "zh-TW": "提供多種文字風格選擇",
      "zh-CN": "提供多种文字风格选择",
      "en": "Multiple text style options available",
      "hi": "कई टेक्स्ट शैली विकल्प उपलब्ध",
      "ja": "複数のテキストスタイルが利用可能",
      "ko": "다양한 텍스트 스타일 옵션 제공"
    },
    "feature2Title": {
      "zh-TW": "假資料",
      "zh-CN": "假数据",
      "en": "Fake Data",
      "hi": "नकली डेटा",
      "ja": "フェイクデータ",
      "ko": "가짜 데이터"
    },
    "feature2Description": {
      "zh-TW": "生成各種測試用假資料",
      "zh-CN": "生成各种测试用假数据",
      "en": "Generate various fake data for testing",
      "hi": "परीक्षण के लिए विभिन्न नकली डेटा जेनरेट करें",
      "ja": "テスト用の様々なフェイクデータを生成",
      "ko": "테스트용 다양한 가짜 데이터 생성"
    },
    "textStyle": { "zh-TW": "文字風格", "zh-CN": "文字风格", "en": "Text Style", "hi": "टेक्स्ट शैली", "ja": "テキストスタイル", "ko": "텍스트 스타일" },
    "chineseRandom": { "zh-TW": "中文隨機", "zh-CN": "中文随机", "en": "Chinese Random", "hi": "चीनी यादृच्छिक", "ja": "中国語ランダム", "ko": "중국어 랜덤" },
    "styleLorem": { "zh-TW": "Lorem Ipsum", "zh-CN": "Lorem Ipsum", "en": "Lorem Ipsum", "hi": "Lorem Ipsum", "ja": "Lorem Ipsum", "ko": "Lorem Ipsum" },
    "styleHipster": { "zh-TW": "Hipster Ipsum (文青風)", "zh-CN": "Hipster Ipsum (文艺风)", "en": "Hipster Ipsum", "hi": "Hipster Ipsum", "ja": "Hipster Ipsum", "ko": "Hipster Ipsum" },
    "styleTech": { "zh-TW": "Tech Ipsum (科技風)", "zh-CN": "Tech Ipsum (科技风)", "en": "Tech Ipsum", "hi": "Tech Ipsum", "ja": "Tech Ipsum", "ko": "Tech Ipsum" },
    "clickGenerate": { "zh-TW": "點擊生成按鈕開始", "zh-CN": "点击生成按钮开始", "en": "Click Generate to Start", "hi": "शुरू करने के लिए जेनरेट पर क्लिक करें", "ja": "生成ボタンをクリックして開始", "ko": "생성 버튼을 클릭하여 시작" },
    "fakeData": { "zh-TW": "假資料", "zh-CN": "假数据", "en": "Fake Data", "hi": "नकली डेटा", "ja": "フェイクデータ", "ko": "가짜 데이터" },
    "includeHtml": { "zh-TW": "包含 HTML 標籤", "zh-CN": "包含 HTML 标签", "en": "Include HTML Tags", "hi": "HTML टैग शामिल करें", "ja": "HTMLタグを含む", "ko": "HTML 태그 포함" },
    "options": { "zh-TW": "選項", "zh-CN": "选项", "en": "Options", "hi": "विकल्प", "ja": "オプション", "ko": "옵션" },
    "paragraphCount": { "zh-TW": "段落數量", "zh-CN": "段落数量", "en": "Paragraph Count", "hi": "पैराग्राफ गिनती", "ja": "段落数", "ko": "단락 수" },
    "quickGenerate": { "zh-TW": "快速生成", "zh-CN": "快速生成", "en": "Quick Generate", "hi": "त्वरित जेनरेट", "ja": "クイック生成", "ko": "빠른 생성" },
    "startWithLorem": { "zh-TW": "以 Lorem ipsum 開頭", "zh-CN": "以 Lorem ipsum 开头", "en": "Start with Lorem ipsum", "hi": "Lorem ipsum से शुरू करें", "ja": "Lorem ipsum で開始", "ko": "Lorem ipsum으로 시작" },
    "wordCount": { "zh-TW": "字數", "zh-CN": "字数", "en": "Word Count", "hi": "शब्द गिनती", "ja": "単語数", "ko": "단어 수" }
  },

  // Diff 比較工具
  "diffTool": {
    "title": {
      "zh-TW": "Diff 比較工具",
      "zh-CN": "Diff 比较工具",
      "en": "Diff Tool",
      "hi": "Diff टूल",
      "ja": "Diffツール",
      "ko": "Diff 도구"
    },
    "description": {
      "zh-TW": "比較兩段文字的差異，支援逐行和逐字比較",
      "zh-CN": "比较两段文字的差异，支持逐行和逐字比较",
      "en": "Compare differences between two texts with line-by-line and word-by-word modes",
      "hi": "दो टेक्स्ट के बीच अंतर की तुलना करें",
      "ja": "2つのテキストの差分を比較（行単位・単語単位）",
      "ko": "두 텍스트 간 차이점 비교 (줄 단위, 단어 단위)"
    },
    "originalText": {
      "zh-TW": "原始文字",
      "zh-CN": "原始文字",
      "en": "Original Text",
      "hi": "मूल टेक्स्ट",
      "ja": "元のテキスト",
      "ko": "원본 텍스트"
    },
    "modifiedText": {
      "zh-TW": "修改後文字",
      "zh-CN": "修改后文字",
      "en": "Modified Text",
      "hi": "संशोधित टेक्स्ट",
      "ja": "変更後のテキスト",
      "ko": "수정된 텍스트"
    },
    "originalPlaceholder": {
      "zh-TW": "輸入原始文字...",
      "zh-CN": "输入原始文字...",
      "en": "Enter original text...",
      "hi": "मूल टेक्स्ट दर्ज करें...",
      "ja": "元のテキストを入力...",
      "ko": "원본 텍스트 입력..."
    },
    "modifiedPlaceholder": {
      "zh-TW": "輸入修改後文字...",
      "zh-CN": "输入修改后文字...",
      "en": "Enter modified text...",
      "hi": "संशोधित टेक्स्ट दर्ज करें...",
      "ja": "変更後のテキストを入力...",
      "ko": "수정된 텍스트 입력..."
    },
    "compare": {
      "zh-TW": "比較",
      "zh-CN": "比较",
      "en": "Compare",
      "hi": "तुलना करें",
      "ja": "比較",
      "ko": "비교"
    },
    "diffResult": {
      "zh-TW": "比較結果",
      "zh-CN": "比较结果",
      "en": "Diff Result",
      "hi": "Diff परिणाम",
      "ja": "比較結果",
      "ko": "비교 결과"
    },
    "viewMode": {
      "zh-TW": "顯示模式",
      "zh-CN": "显示模式",
      "en": "View Mode",
      "hi": "व्यू मोड",
      "ja": "表示モード",
      "ko": "보기 모드"
    },
    "splitView": {
      "zh-TW": "分欄顯示",
      "zh-CN": "分栏显示",
      "en": "Split View",
      "hi": "स्प्लिट व्यू",
      "ja": "分割表示",
      "ko": "분할 보기"
    },
    "unifiedView": {
      "zh-TW": "統一顯示",
      "zh-CN": "统一显示",
      "en": "Unified View",
      "hi": "यूनिफाइड व्यू",
      "ja": "統合表示",
      "ko": "통합 보기"
    },
    "diffMode": {
      "zh-TW": "比較模式",
      "zh-CN": "比较模式",
      "en": "Diff Mode",
      "hi": "Diff मोड",
      "ja": "比較モード",
      "ko": "비교 모드"
    },
    "lineMode": {
      "zh-TW": "逐行比較",
      "zh-CN": "逐行比较",
      "en": "Line by Line",
      "hi": "लाइन दर लाइन",
      "ja": "行単位",
      "ko": "줄 단위"
    },
    "wordMode": {
      "zh-TW": "逐字比較",
      "zh-CN": "逐字比较",
      "en": "Word by Word",
      "hi": "शब्द दर शब्द",
      "ja": "単語単位",
      "ko": "단어 단위"
    },
    "charMode": {
      "zh-TW": "逐字元比較",
      "zh-CN": "逐字符比较",
      "en": "Character by Character",
      "hi": "वर्ण दर वर्ण",
      "ja": "文字単位",
      "ko": "문자 단위"
    },
    "additions": {
      "zh-TW": "新增",
      "zh-CN": "新增",
      "en": "Additions",
      "hi": "जोड़",
      "ja": "追加",
      "ko": "추가"
    },
    "deletions": {
      "zh-TW": "刪除",
      "zh-CN": "删除",
      "en": "Deletions",
      "hi": "हटाया",
      "ja": "削除",
      "ko": "삭제"
    },
    "unchanged": {
      "zh-TW": "未變更",
      "zh-CN": "未变更",
      "en": "Unchanged",
      "hi": "अपरिवर्तित",
      "ja": "変更なし",
      "ko": "변경 없음"
    },
    "noDifferences": {
      "zh-TW": "沒有差異",
      "zh-CN": "没有差异",
      "en": "No differences",
      "hi": "कोई अंतर नहीं",
      "ja": "差分なし",
      "ko": "차이 없음"
    },
    "statistics": {
      "zh-TW": "統計",
      "zh-CN": "统计",
      "en": "Statistics",
      "hi": "आंकड़े",
      "ja": "統計",
      "ko": "통계"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "多種比較模式",
      "zh-CN": "多种比较模式",
      "en": "Multiple Modes",
      "hi": "कई मोड",
      "ja": "複数モード",
      "ko": "다중 모드"
    },
    "feature1Description": {
      "zh-TW": "支援行、詞、字元級別比較",
      "zh-CN": "支持行、词、字符级别比较",
      "en": "Support line, word, and character level comparison",
      "hi": "लाइन, शब्द और वर्ण स्तर की तुलना का समर्थन",
      "ja": "行、単語、文字レベルの比較をサポート",
      "ko": "줄, 단어, 문자 수준 비교 지원"
    },
    "feature2Title": {
      "zh-TW": "分欄/統一視圖",
      "zh-CN": "分栏/统一视图",
      "en": "Split/Unified View",
      "hi": "स्प्लिट/यूनिफाइड व्यू",
      "ja": "分割/統合ビュー",
      "ko": "분할/통합 보기"
    },
    "feature2Description": {
      "zh-TW": "可切換顯示方式",
      "zh-CN": "可切换显示方式",
      "en": "Toggle between display modes",
      "hi": "डिस्प्ले मोड के बीच टॉगल करें",
      "ja": "表示モードを切り替え可能",
      "ko": "표시 모드 전환 가능"
    },
    "original": { "zh-TW": "原始", "zh-CN": "原始", "en": "Original", "hi": "मूल", "ja": "オリジナル", "ko": "원본" },
    "modified": { "zh-TW": "修改後", "zh-CN": "修改后", "en": "Modified", "hi": "संशोधित", "ja": "変更後", "ko": "수정됨" },
    "byLines": { "zh-TW": "逐行", "zh-CN": "逐行", "en": "By Lines", "hi": "लाइन द्वारा", "ja": "行単位", "ko": "줄 단위" },
    "byWords": { "zh-TW": "逐字", "zh-CN": "逐字", "en": "By Words", "hi": "शब्द द्वारा", "ja": "単語単位", "ko": "단어 단위" },
    "byChars": { "zh-TW": "逐字元", "zh-CN": "逐字符", "en": "By Characters", "hi": "वर्ण द्वारा", "ja": "文字単位", "ko": "문자 단위" },
    "displayMode": { "zh-TW": "顯示模式", "zh-CN": "显示模式", "en": "Display Mode", "hi": "डिस्प्ले मोड", "ja": "表示モード", "ko": "표시 모드" },
    "ignoreWhitespace": { "zh-TW": "忽略空白", "zh-CN": "忽略空白", "en": "Ignore Whitespace", "hi": "व्हाइटस्पेस अनदेखा करें", "ja": "空白を無視", "ko": "공백 무시" },
    "ignoreCase": { "zh-TW": "忽略大小寫", "zh-CN": "忽略大小写", "en": "Ignore Case", "hi": "केस अनदेखा करें", "ja": "大文字小文字を無視", "ko": "대소문자 무시" },
    "added": { "zh-TW": "新增", "zh-CN": "新增", "en": "Added", "hi": "जोड़ा गया", "ja": "追加", "ko": "추가됨" },
    "removed": { "zh-TW": "刪除", "zh-CN": "删除", "en": "Removed", "hi": "हटाया गया", "ja": "削除", "ko": "삭제됨" },
    "changed": { "zh-TW": "變更", "zh-CN": "变更", "en": "Changed", "hi": "बदला गया", "ja": "変更", "ko": "변경됨" },
    "result": { "zh-TW": "比較結果", "zh-CN": "比较结果", "en": "Result", "hi": "परिणाम", "ja": "結果", "ko": "결과" }
  },

  // CURL 轉換器
  "curlConverter": {
    "title": {
      "zh-TW": "CURL 轉換器",
      "zh-CN": "CURL 转换器",
      "en": "CURL Converter",
      "hi": "CURL कनवर्टर",
      "ja": "CURL変換",
      "ko": "CURL 변환기"
    },
    "description": {
      "zh-TW": "將 CURL 命令轉換為各種程式語言的 HTTP 請求代碼",
      "zh-CN": "将 CURL 命令转换为各种编程语言的 HTTP 请求代码",
      "en": "Convert CURL commands to HTTP request code in various programming languages",
      "hi": "CURL कमांड को विभिन्न प्रोग्रामिंग भाषाओं में HTTP अनुरोध कोड में बदलें",
      "ja": "CURLコマンドを各種プログラミング言語のHTTPリクエストコードに変換",
      "ko": "CURL 명령을 다양한 프로그래밍 언어의 HTTP 요청 코드로 변환"
    },
    "curlCommand": {
      "zh-TW": "CURL 命令",
      "zh-CN": "CURL 命令",
      "en": "CURL Command",
      "hi": "CURL कमांड",
      "ja": "CURLコマンド",
      "ko": "CURL 명령"
    },
    "curlPlaceholder": {
      "zh-TW": "貼上 CURL 命令...",
      "zh-CN": "粘贴 CURL 命令...",
      "en": "Paste CURL command...",
      "hi": "CURL कमांड पेस्ट करें...",
      "ja": "CURLコマンドを貼り付け...",
      "ko": "CURL 명령 붙여넣기..."
    },
    "targetLanguage": {
      "zh-TW": "目標語言",
      "zh-CN": "目标语言",
      "en": "Target Language",
      "hi": "लक्ष्य भाषा",
      "ja": "ターゲット言語",
      "ko": "대상 언어"
    },
    "convert": {
      "zh-TW": "轉換",
      "zh-CN": "转换",
      "en": "Convert",
      "hi": "बदलें",
      "ja": "変換",
      "ko": "변환"
    },
    "generatedCode": {
      "zh-TW": "生成的代碼",
      "zh-CN": "生成的代码",
      "en": "Generated Code",
      "hi": "जेनरेट किया गया कोड",
      "ja": "生成されたコード",
      "ko": "생성된 코드"
    },
    "parsedRequest": {
      "zh-TW": "解析的請求",
      "zh-CN": "解析的请求",
      "en": "Parsed Request",
      "hi": "पार्स किया गया अनुरोध",
      "ja": "解析されたリクエスト",
      "ko": "파싱된 요청"
    },
    "method": {
      "zh-TW": "方法",
      "zh-CN": "方法",
      "en": "Method",
      "hi": "विधि",
      "ja": "メソッド",
      "ko": "메서드"
    },
    "url": {
      "zh-TW": "URL",
      "zh-CN": "URL",
      "en": "URL",
      "hi": "URL",
      "ja": "URL",
      "ko": "URL"
    },
    "headers": {
      "zh-TW": "標頭",
      "zh-CN": "标头",
      "en": "Headers",
      "hi": "हेडर्स",
      "ja": "ヘッダー",
      "ko": "헤더"
    },
    "body": {
      "zh-TW": "請求內容",
      "zh-CN": "请求内容",
      "en": "Body",
      "hi": "बॉडी",
      "ja": "ボディ",
      "ko": "본문"
    },
    "invalidCurl": {
      "zh-TW": "無效的 CURL 命令",
      "zh-CN": "无效的 CURL 命令",
      "en": "Invalid CURL command",
      "hi": "अमान्य CURL कमांड",
      "ja": "無効なCURLコマンド",
      "ko": "잘못된 CURL 명령"
    },
    "examples": {
      "zh-TW": "範例",
      "zh-CN": "示例",
      "en": "Examples",
      "hi": "उदाहरण",
      "ja": "例",
      "ko": "예시"
    },
    "simpleGet": {
      "zh-TW": "簡單 GET",
      "zh-CN": "简单 GET",
      "en": "Simple GET",
      "hi": "सिंपल GET",
      "ja": "シンプルGET",
      "ko": "간단한 GET"
    },
    "postJson": {
      "zh-TW": "POST JSON",
      "zh-CN": "POST JSON",
      "en": "POST JSON",
      "hi": "POST JSON",
      "ja": "POST JSON",
      "ko": "POST JSON"
    },
    "withAuth": {
      "zh-TW": "帶身份驗證",
      "zh-CN": "带身份验证",
      "en": "With Auth",
      "hi": "प्रमाणीकरण के साथ",
      "ja": "認証付き",
      "ko": "인증 포함"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "多語言支援",
      "zh-CN": "多语言支持",
      "en": "Multi-language",
      "hi": "बहु-भाषा",
      "ja": "多言語対応",
      "ko": "다국어 지원"
    },
    "feature1Description": {
      "zh-TW": "支援 JavaScript、Python、PHP 等多種語言",
      "zh-CN": "支持 JavaScript、Python、PHP 等多种语言",
      "en": "Supports JavaScript, Python, PHP and more",
      "hi": "JavaScript, Python, PHP और अधिक का समर्थन",
      "ja": "JavaScript、Python、PHPなどをサポート",
      "ko": "JavaScript, Python, PHP 등 지원"
    },
    "feature2Title": {
      "zh-TW": "完整解析",
      "zh-CN": "完整解析",
      "en": "Full Parsing",
      "hi": "पूर्ण पार्सिंग",
      "ja": "完全解析",
      "ko": "완전 파싱"
    },
    "feature2Description": {
      "zh-TW": "解析所有 CURL 選項和參數",
      "zh-CN": "解析所有 CURL 选项和参数",
      "en": "Parses all CURL options and parameters",
      "hi": "सभी CURL विकल्प और पैरामीटर पार्स करता है",
      "ja": "すべてのCURLオプションとパラメータを解析",
      "ko": "모든 CURL 옵션 및 매개변수 파싱"
    },
    "placeholder": {
      "zh-TW": "輸入 CURL 命令...",
      "zh-CN": "输入 CURL 命令...",
      "en": "Enter CURL command...",
      "hi": "CURL कमांड दर्ज करें...",
      "ja": "CURLコマンドを入力...",
      "ko": "CURL 명령 입력..."
    }
  },

  // Mock API 生成器
  "mockApiGenerator": {
    "title": {
      "zh-TW": "Mock API 生成器",
      "zh-CN": "Mock API 生成器",
      "en": "Mock API Generator",
      "hi": "Mock API जेनरेटर",
      "ja": "Mock APIジェネレーター",
      "ko": "Mock API 생성기"
    },
    "description": {
      "zh-TW": "生成模擬 JSON 資料和假 API 回應，用於前端開發測試",
      "zh-CN": "生成模拟 JSON 数据和假 API 响应，用于前端开发测试",
      "en": "Generate mock JSON data and fake API responses for frontend development testing",
      "hi": "फ्रंटएंड विकास परीक्षण के लिए मॉक JSON डेटा और नकली API प्रतिक्रियाएं जेनरेट करें",
      "ja": "フロントエンド開発テスト用のモックJSONデータとフェイクAPIレスポンスを生成",
      "ko": "프론트엔드 개발 테스트용 모의 JSON 데이터 및 가짜 API 응답 생성"
    },
    "schemaEditor": {
      "zh-TW": "Schema 編輯器",
      "zh-CN": "Schema 编辑器",
      "en": "Schema Editor",
      "hi": "स्कीमा एडिटर",
      "ja": "Schemaエディター",
      "ko": "스키마 편집기"
    },
    "schemaPlaceholder": {
      "zh-TW": "定義資料結構...",
      "zh-CN": "定义数据结构...",
      "en": "Define data structure...",
      "hi": "डेटा संरचना परिभाषित करें...",
      "ja": "データ構造を定義...",
      "ko": "데이터 구조 정의..."
    },
    "templates": {
      "zh-TW": "範本",
      "zh-CN": "模板",
      "en": "Templates",
      "hi": "टेम्पलेट्स",
      "ja": "テンプレート",
      "ko": "템플릿"
    },
    "simpleUser": {
      "zh-TW": "簡單用戶",
      "zh-CN": "简单用户",
      "en": "Simple User",
      "hi": "सिंपल यूज़र",
      "ja": "シンプルユーザー",
      "ko": "간단한 사용자"
    },
    "productList": {
      "zh-TW": "產品列表",
      "zh-CN": "产品列表",
      "en": "Product List",
      "hi": "उत्पाद सूची",
      "ja": "製品リスト",
      "ko": "제품 목록"
    },
    "apiResponse": {
      "zh-TW": "API 回應",
      "zh-CN": "API 响应",
      "en": "API Response",
      "hi": "API प्रतिक्रिया",
      "ja": "APIレスポンス",
      "ko": "API 응답"
    },
    "blogPost": {
      "zh-TW": "部落格文章",
      "zh-CN": "博客文章",
      "en": "Blog Post",
      "hi": "ब्लॉग पोस्ट",
      "ja": "ブログ投稿",
      "ko": "블로그 포스트"
    },
    "recordCount": {
      "zh-TW": "記錄數量",
      "zh-CN": "记录数量",
      "en": "Record Count",
      "hi": "रिकॉर्ड गिनती",
      "ja": "レコード数",
      "ko": "레코드 수"
    },
    "generateData": {
      "zh-TW": "生成資料",
      "zh-CN": "生成数据",
      "en": "Generate Data",
      "hi": "डेटा जेनरेट करें",
      "ja": "データを生成",
      "ko": "데이터 생성"
    },
    "generatedData": {
      "zh-TW": "生成的資料",
      "zh-CN": "生成的数据",
      "en": "Generated Data",
      "hi": "जेनरेट किया गया डेटा",
      "ja": "生成されたデータ",
      "ko": "생성된 데이터"
    },
    "dataTypes": {
      "zh-TW": "支援的資料類型",
      "zh-CN": "支持的数据类型",
      "en": "Supported Data Types",
      "hi": "समर्थित डेटा प्रकार",
      "ja": "サポートされるデータタイプ",
      "ko": "지원되는 데이터 유형"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "自訂 Schema",
      "zh-CN": "自定义 Schema",
      "en": "Custom Schema",
      "hi": "कस्टम स्कीमा",
      "ja": "カスタムSchema",
      "ko": "커스텀 스키마"
    },
    "feature1Description": {
      "zh-TW": "定義您需要的資料結構",
      "zh-CN": "定义您需要的数据结构",
      "en": "Define your desired data structure",
      "hi": "अपनी वांछित डेटा संरचना परिभाषित करें",
      "ja": "必要なデータ構造を定義",
      "ko": "원하는 데이터 구조 정의"
    },
    "feature2Title": {
      "zh-TW": "批量生成",
      "zh-CN": "批量生成",
      "en": "Batch Generate",
      "hi": "बैच जेनरेट",
      "ja": "一括生成",
      "ko": "일괄 생성"
    },
    "feature2Description": {
      "zh-TW": "一次生成多筆測試資料",
      "zh-CN": "一次生成多条测试数据",
      "en": "Generate multiple test records at once",
      "hi": "एक बार में कई टेस्ट रिकॉर्ड जेनरेट करें",
      "ja": "一度に複数のテストデータを生成",
      "ko": "한 번에 여러 테스트 레코드 생성"
    },
    "typeString": { "zh-TW": "字串", "zh-CN": "字符串", "en": "String", "hi": "स्ट्रिंग", "ja": "文字列", "ko": "문자열" },
    "typeNumber": { "zh-TW": "數字", "zh-CN": "数字", "en": "Number", "hi": "संख्या", "ja": "数値", "ko": "숫자" },
    "typeBoolean": { "zh-TW": "布林值", "zh-CN": "布尔值", "en": "Boolean", "hi": "बूलियन", "ja": "ブール値", "ko": "불리언" },
    "typeDate": { "zh-TW": "日期", "zh-CN": "日期", "en": "Date", "hi": "दिनांक", "ja": "日付", "ko": "날짜" },
    "typeUuid": { "zh-TW": "UUID", "zh-CN": "UUID", "en": "UUID", "hi": "UUID", "ja": "UUID", "ko": "UUID" },
    "typeEmail": { "zh-TW": "電子郵件", "zh-CN": "电子邮件", "en": "Email", "hi": "ईमेल", "ja": "メールアドレス", "ko": "이메일" },
    "typeName": { "zh-TW": "姓名", "zh-CN": "姓名", "en": "Name", "hi": "नाम", "ja": "名前", "ko": "이름" },
    "typePhone": { "zh-TW": "電話", "zh-CN": "电话", "en": "Phone", "hi": "फ़ोन", "ja": "電話番号", "ko": "전화번호" },
    "typeAddress": { "zh-TW": "地址", "zh-CN": "地址", "en": "Address", "hi": "पता", "ja": "住所", "ko": "주소" },
    "typeCompany": { "zh-TW": "公司", "zh-CN": "公司", "en": "Company", "hi": "कंपनी", "ja": "会社", "ko": "회사" },
    "typeUrl": { "zh-TW": "網址", "zh-CN": "网址", "en": "URL", "hi": "URL", "ja": "URL", "ko": "URL" },
    "typeImageUrl": { "zh-TW": "圖片網址", "zh-CN": "图片网址", "en": "Image URL", "hi": "इमेज URL", "ja": "画像URL", "ko": "이미지 URL" },
    "typeParagraph": { "zh-TW": "段落", "zh-CN": "段落", "en": "Paragraph", "hi": "पैराग्राफ", "ja": "段落", "ko": "단락" },
    "typeCustom": { "zh-TW": "自訂", "zh-CN": "自定义", "en": "Custom", "hi": "कस्टम", "ja": "カスタム", "ko": "사용자 정의" },
    "formatJson": { "zh-TW": "JSON", "zh-CN": "JSON", "en": "JSON", "hi": "JSON", "ja": "JSON", "ko": "JSON" },
    "formatJsonArray": { "zh-TW": "JSON 陣列", "zh-CN": "JSON 数组", "en": "JSON Array", "hi": "JSON एरे", "ja": "JSON配列", "ko": "JSON 배열" },
    "formatCsv": { "zh-TW": "CSV", "zh-CN": "CSV", "en": "CSV", "hi": "CSV", "ja": "CSV", "ko": "CSV" },
    "addField": { "zh-TW": "新增欄位", "zh-CN": "添加字段", "en": "Add Field", "hi": "फ़ील्ड जोड़ें", "ja": "フィールドを追加", "ko": "필드 추가" },
    "count": { "zh-TW": "數量", "zh-CN": "数量", "en": "Count", "hi": "गिनती", "ja": "件数", "ko": "개수" },
    "customValue": { "zh-TW": "自訂值", "zh-CN": "自定义值", "en": "Custom Value", "hi": "कस्टम मान", "ja": "カスタム値", "ko": "사용자 정의 값" },
    "fieldName": { "zh-TW": "欄位名稱", "zh-CN": "字段名称", "en": "Field Name", "hi": "फ़ील्ड नाम", "ja": "フィールド名", "ko": "필드 이름" },
    "format": { "zh-TW": "格式", "zh-CN": "格式", "en": "Format", "hi": "फॉर्मेट", "ja": "フォーマット", "ko": "형식" },
    "generate": { "zh-TW": "生成", "zh-CN": "生成", "en": "Generate", "hi": "जेनरेट करें", "ja": "生成", "ko": "생성" },
    "noWrapper": { "zh-TW": "無包裝", "zh-CN": "无包装", "en": "No Wrapper", "hi": "कोई रैपर नहीं", "ja": "ラッパーなし", "ko": "래퍼 없음" },
    "options": { "zh-TW": "選項", "zh-CN": "选项", "en": "Options", "hi": "विकल्प", "ja": "オプション", "ko": "옵션" },
    "schema": { "zh-TW": "Schema", "zh-CN": "Schema", "en": "Schema", "hi": "स्कीमा", "ja": "スキーマ", "ko": "스키마" },
    "wrapper": { "zh-TW": "包裝", "zh-CN": "包装", "en": "Wrapper", "hi": "रैपर", "ja": "ラッパー", "ko": "래퍼" }
  },

  // WebSocket 測試器
  "webSocketTester": {
    "title": {
      "zh-TW": "WebSocket 測試器",
      "zh-CN": "WebSocket 测试器",
      "en": "WebSocket Tester",
      "hi": "WebSocket टेस्टर",
      "ja": "WebSocketテスター",
      "ko": "WebSocket 테스터"
    },
    "description": {
      "zh-TW": "測試 WebSocket 連接，發送和接收即時訊息",
      "zh-CN": "测试 WebSocket 连接，发送和接收实时消息",
      "en": "Test WebSocket connections, send and receive real-time messages",
      "hi": "WebSocket कनेक्शन टेस्ट करें, रीयल-टाइम संदेश भेजें और प्राप्त करें",
      "ja": "WebSocket接続をテストし、リアルタイムメッセージを送受信",
      "ko": "WebSocket 연결 테스트, 실시간 메시지 송수신"
    },
    "connection": {
      "zh-TW": "連接設置",
      "zh-CN": "连接设置",
      "en": "Connection",
      "hi": "कनेक्शन",
      "ja": "接続",
      "ko": "연결"
    },
    "serverUrl": {
      "zh-TW": "伺服器 URL",
      "zh-CN": "服务器 URL",
      "en": "Server URL",
      "hi": "सर्वर URL",
      "ja": "サーバーURL",
      "ko": "서버 URL"
    },
    "urlPlaceholder": {
      "zh-TW": "wss://example.com/socket",
      "zh-CN": "wss://example.com/socket",
      "en": "wss://example.com/socket",
      "hi": "wss://example.com/socket",
      "ja": "wss://example.com/socket",
      "ko": "wss://example.com/socket"
    },
    "connect": {
      "zh-TW": "連接",
      "zh-CN": "连接",
      "en": "Connect",
      "hi": "कनेक्ट",
      "ja": "接続",
      "ko": "연결"
    },
    "disconnect": {
      "zh-TW": "斷開連接",
      "zh-CN": "断开连接",
      "en": "Disconnect",
      "hi": "डिस्कनेक्ट",
      "ja": "切断",
      "ko": "연결 끊기"
    },
    "statusConnected": {
      "zh-TW": "已連接",
      "zh-CN": "已连接",
      "en": "Connected",
      "hi": "कनेक्ट हुआ",
      "ja": "接続済み",
      "ko": "연결됨"
    },
    "statusConnecting": {
      "zh-TW": "連接中...",
      "zh-CN": "连接中...",
      "en": "Connecting...",
      "hi": "कनेक्ट हो रहा है...",
      "ja": "接続中...",
      "ko": "연결 중..."
    },
    "statusDisconnected": {
      "zh-TW": "已斷開",
      "zh-CN": "已断开",
      "en": "Disconnected",
      "hi": "डिस्कनेक्ट हुआ",
      "ja": "切断済み",
      "ko": "연결 끊김"
    },
    "statusIdle": {
      "zh-TW": "待機中",
      "zh-CN": "待机中",
      "en": "Idle",
      "hi": "निष्क्रिय",
      "ja": "待機中",
      "ko": "대기 중"
    },
    "connectedFor": {
      "zh-TW": "已連接時間",
      "zh-CN": "已连接时间",
      "en": "Connected for",
      "hi": "कनेक्ट समय",
      "ja": "接続時間",
      "ko": "연결 시간"
    },
    "sendMessage": {
      "zh-TW": "發送訊息",
      "zh-CN": "发送消息",
      "en": "Send Message",
      "hi": "संदेश भेजें",
      "ja": "メッセージ送信",
      "ko": "메시지 보내기"
    },
    "textPlaceholder": {
      "zh-TW": "輸入要發送的訊息...",
      "zh-CN": "输入要发送的消息...",
      "en": "Enter message to send...",
      "hi": "भेजने के लिए संदेश दर्ज करें...",
      "ja": "送信するメッセージを入力...",
      "ko": "보낼 메시지 입력..."
    },
    "jsonPlaceholder": {
      "zh-TW": "輸入 JSON 訊息...",
      "zh-CN": "输入 JSON 消息...",
      "en": "Enter JSON message...",
      "hi": "JSON संदेश दर्ज करें...",
      "ja": "JSONメッセージを入力...",
      "ko": "JSON 메시지 입력..."
    },
    "formatJson": {
      "zh-TW": "格式化 JSON",
      "zh-CN": "格式化 JSON",
      "en": "Format JSON",
      "hi": "JSON फॉर्मेट करें",
      "ja": "JSONをフォーマット",
      "ko": "JSON 포맷"
    },
    "send": {
      "zh-TW": "發送",
      "zh-CN": "发送",
      "en": "Send",
      "hi": "भेजें",
      "ja": "送信",
      "ko": "보내기"
    },
    "autoSend": {
      "zh-TW": "自動發送",
      "zh-CN": "自动发送",
      "en": "Auto Send",
      "hi": "ऑटो सेंड",
      "ja": "自動送信",
      "ko": "자동 전송"
    },
    "messages": {
      "zh-TW": "訊息紀錄",
      "zh-CN": "消息记录",
      "en": "Messages",
      "hi": "संदेश",
      "ja": "メッセージ",
      "ko": "메시지"
    },
    "autoScroll": {
      "zh-TW": "自動捲動",
      "zh-CN": "自动滚动",
      "en": "Auto Scroll",
      "hi": "ऑटो स्क्रॉल",
      "ja": "自動スクロール",
      "ko": "자동 스크롤"
    },
    "noMessages": {
      "zh-TW": "沒有訊息",
      "zh-CN": "没有消息",
      "en": "No messages",
      "hi": "कोई संदेश नहीं",
      "ja": "メッセージなし",
      "ko": "메시지 없음"
    },
    "testServers": {
      "zh-TW": "測試伺服器",
      "zh-CN": "测试服务器",
      "en": "Test Servers",
      "hi": "टेस्ट सर्वर",
      "ja": "テストサーバー",
      "ko": "테스트 서버"
    },
    "featuresTitle": {
      "zh-TW": "功能特點",
      "zh-CN": "功能特点",
      "en": "Features",
      "hi": "विशेषताएं",
      "ja": "機能",
      "ko": "기능"
    },
    "feature1Title": {
      "zh-TW": "即時通訊",
      "zh-CN": "即时通讯",
      "en": "Real-time Communication",
      "hi": "रीयल-टाइम संचार",
      "ja": "リアルタイム通信",
      "ko": "실시간 통신"
    },
    "feature1Description": {
      "zh-TW": "測試 WebSocket 雙向通訊",
      "zh-CN": "测试 WebSocket 双向通讯",
      "en": "Test WebSocket bidirectional communication",
      "hi": "WebSocket द्विदिशीय संचार का परीक्षण करें",
      "ja": "WebSocket双方向通信をテスト",
      "ko": "WebSocket 양방향 통신 테스트"
    },
    "feature2Title": {
      "zh-TW": "訊息日誌",
      "zh-CN": "消息日志",
      "en": "Message Log",
      "hi": "संदेश लॉग",
      "ja": "メッセージログ",
      "ko": "메시지 로그"
    },
    "feature2Description": {
      "zh-TW": "完整記錄所有收發訊息",
      "zh-CN": "完整记录所有收发消息",
      "en": "Complete log of all sent/received messages",
      "hi": "सभी भेजे/प्राप्त संदेशों का पूर्ण लॉग",
      "ja": "すべての送受信メッセージの完全なログ",
      "ko": "모든 송수신 메시지의 전체 로그"
    },
    "textFormat": { "zh-TW": "純文字", "zh-CN": "纯文本", "en": "Text", "hi": "टेक्स्ट", "ja": "テキスト", "ko": "텍스트" },
    "jsonFormat": { "zh-TW": "JSON", "zh-CN": "JSON", "en": "JSON", "hi": "JSON", "ja": "JSON", "ko": "JSON" }
  },

  // JavaScript/CSS 壓縮器
  "jsCssMinifier": {
    "title": {
      "zh-TW": "JS/CSS 壓縮器",
      "zh-CN": "JS/CSS 压缩器",
      "en": "JS/CSS Minifier",
      "hi": "JS/CSS मिनीफायर",
      "ja": "JS/CSS 圧縮ツール",
      "ko": "JS/CSS 압축기"
    },
    "description": {
      "zh-TW": "壓縮和美化 JavaScript 與 CSS 程式碼，減少檔案大小",
      "zh-CN": "压缩和美化 JavaScript 与 CSS 代码，减少文件大小",
      "en": "Minify and beautify JavaScript and CSS code to reduce file size",
      "hi": "फ़ाइल आकार कम करने के लिए JavaScript और CSS कोड को छोटा करें",
      "ja": "ファイルサイズを削減するためにJavaScriptとCSSコードを圧縮・整形",
      "ko": "파일 크기를 줄이기 위해 JavaScript 및 CSS 코드 압축 및 정리"
    },
    "input": { "zh-TW": "輸入", "zh-CN": "输入", "en": "Input", "hi": "इनपुट", "ja": "入力", "ko": "입력" },
    "output": { "zh-TW": "輸出", "zh-CN": "输出", "en": "Output", "hi": "आउटपुट", "ja": "出力", "ko": "출력" },
    "minify": { "zh-TW": "壓縮", "zh-CN": "压缩", "en": "Minify", "hi": "छोटा करें", "ja": "圧縮", "ko": "압축" },
    "beautify": { "zh-TW": "美化", "zh-CN": "美化", "en": "Beautify", "hi": "सुंदर बनाएं", "ja": "整形", "ko": "정리" },
    "loadSample": { "zh-TW": "載入範例", "zh-CN": "加载示例", "en": "Load Sample", "hi": "नमूना लोड करें", "ja": "サンプルを読み込む", "ko": "샘플 로드" },
    "clear": { "zh-TW": "清除", "zh-CN": "清除", "en": "Clear", "hi": "साफ़ करें", "ja": "クリア", "ko": "지우기" },
    "copy": { "zh-TW": "複製", "zh-CN": "复制", "en": "Copy", "hi": "कॉपी", "ja": "コピー", "ko": "복사" },
    "copied": { "zh-TW": "已複製", "zh-CN": "已复制", "en": "Copied", "hi": "कॉपी किया गया", "ja": "コピーしました", "ko": "복사됨" },
    "inputSize": { "zh-TW": "輸入大小", "zh-CN": "输入大小", "en": "Input Size", "hi": "इनपुट आकार", "ja": "入力サイズ", "ko": "입력 크기" },
    "outputSize": { "zh-TW": "輸出大小", "zh-CN": "输出大小", "en": "Output Size", "hi": "आउटपुट आकार", "ja": "出力サイズ", "ko": "출력 크기" },
    "saved": { "zh-TW": "節省", "zh-CN": "节省", "en": "Saved", "hi": "बचाया", "ja": "削減", "ko": "절약" },
    "processing": { "zh-TW": "處理中...", "zh-CN": "处理中...", "en": "Processing...", "hi": "प्रोसेसिंग...", "ja": "処理中...", "ko": "처리 중..." },
    "error": { "zh-TW": "錯誤", "zh-CN": "错误", "en": "Error", "hi": "त्रुटि", "ja": "エラー", "ko": "오류" },
    "options": { "zh-TW": "選項", "zh-CN": "选项", "en": "Options", "hi": "विकल्प", "ja": "オプション", "ko": "옵션" },
    "removeComments": { "zh-TW": "移除註釋", "zh-CN": "移除注释", "en": "Remove Comments", "hi": "टिप्पणियां हटाएं", "ja": "コメントを削除", "ko": "주석 제거" },
    "removeWhitespace": { "zh-TW": "移除空白", "zh-CN": "移除空白", "en": "Remove Whitespace", "hi": "व्हाइटस्पेस हटाएं", "ja": "空白を削除", "ko": "공백 제거" },
    "mergeSelectors": { "zh-TW": "合併選擇器", "zh-CN": "合并选择器", "en": "Merge Selectors", "hi": "सेलेक्टर मर्ज करें", "ja": "セレクタをマージ", "ko": "선택자 병합" },
    "jsPlaceholder": { "zh-TW": "貼上 JavaScript 程式碼...", "zh-CN": "粘贴 JavaScript 代码...", "en": "Paste JavaScript code...", "hi": "JavaScript कोड पेस्ट करें...", "ja": "JavaScriptコードを貼り付け...", "ko": "JavaScript 코드 붙여넣기..." },
    "cssPlaceholder": { "zh-TW": "貼上 CSS 程式碼...", "zh-CN": "粘贴 CSS 代码...", "en": "Paste CSS code...", "hi": "CSS कोड पेस्ट करें...", "ja": "CSSコードを貼り付け...", "ko": "CSS 코드 붙여넣기..." },
    "outputPlaceholder": { "zh-TW": "處理後的程式碼將顯示在這裡", "zh-CN": "处理后的代码将显示在这里", "en": "Processed code will appear here", "hi": "प्रोसेस किया गया कोड यहां दिखाई देगा", "ja": "処理後のコードがここに表示されます", "ko": "처리된 코드가 여기에 표시됩니다" },
    "featuresTitle": { "zh-TW": "功能特色", "zh-CN": "功能特色", "en": "Features", "hi": "विशेषताएं", "ja": "機能", "ko": "기능" },
    "feature1": { "zh-TW": "支援 JavaScript 和 CSS 壓縮", "zh-CN": "支持 JavaScript 和 CSS 压缩", "en": "Supports JavaScript and CSS minification", "hi": "JavaScript और CSS संपीड़न का समर्थन", "ja": "JavaScriptとCSSの圧縮をサポート", "ko": "JavaScript 및 CSS 압축 지원" },
    "feature2": { "zh-TW": "即時顯示壓縮比例", "zh-CN": "即时显示压缩比例", "en": "Real-time compression ratio display", "hi": "वास्तविक समय संपीड़न अनुपात प्रदर्शन", "ja": "リアルタイム圧縮率表示", "ko": "실시간 압축 비율 표시" },
    "feature3": { "zh-TW": "可選擇保留或移除註釋", "zh-CN": "可选择保留或移除注释", "en": "Option to keep or remove comments", "hi": "टिप्पणियां रखने या हटाने का विकल्प", "ja": "コメントを保持または削除するオプション", "ko": "주석 유지 또는 제거 옵션" },
    "feature4": { "zh-TW": "支援程式碼美化格式化", "zh-CN": "支持代码美化格式化", "en": "Supports code beautification", "hi": "कोड सुंदरीकरण का समर्थन", "ja": "コード整形をサポート", "ko": "코드 정리 지원" }
  },

  // SQL 格式化器
  "sqlFormatter": {
    "title": {
      "zh-TW": "SQL 格式化器",
      "zh-CN": "SQL 格式化器",
      "en": "SQL Formatter",
      "hi": "SQL फॉर्मेटर",
      "ja": "SQL フォーマッター",
      "ko": "SQL 포맷터"
    },
    "description": {
      "zh-TW": "格式化和美化 SQL 查詢語句，支援多種 SQL 方言",
      "zh-CN": "格式化和美化 SQL 查询语句，支持多种 SQL 方言",
      "en": "Format and beautify SQL queries with support for multiple SQL dialects",
      "hi": "एकाधिक SQL बोलियों के समर्थन के साथ SQL क्वेरी को फॉर्मेट करें",
      "ja": "複数のSQL方言をサポートしてSQLクエリをフォーマット・整形",
      "ko": "여러 SQL 방언을 지원하는 SQL 쿼리 포맷 및 정리"
    },
    "input": { "zh-TW": "輸入 SQL", "zh-CN": "输入 SQL", "en": "Input SQL", "hi": "इनपुट SQL", "ja": "入力SQL", "ko": "입력 SQL" },
    "output": { "zh-TW": "輸出", "zh-CN": "输出", "en": "Output", "hi": "आउटपुट", "ja": "出力", "ko": "출력" },
    "format": { "zh-TW": "格式化", "zh-CN": "格式化", "en": "Format", "hi": "फॉर्मेट", "ja": "フォーマット", "ko": "포맷" },
    "minify": { "zh-TW": "壓縮", "zh-CN": "压缩", "en": "Minify", "hi": "छोटा करें", "ja": "圧縮", "ko": "압축" },
    "loadSample": { "zh-TW": "載入範例", "zh-CN": "加载示例", "en": "Load Sample", "hi": "नमूना लोड करें", "ja": "サンプルを読み込む", "ko": "샘플 로드" },
    "clear": { "zh-TW": "清除", "zh-CN": "清除", "en": "Clear", "hi": "साफ़ करें", "ja": "クリア", "ko": "지우기" },
    "copy": { "zh-TW": "複製", "zh-CN": "复制", "en": "Copy", "hi": "कॉपी", "ja": "コピー", "ko": "복사" },
    "copied": { "zh-TW": "已複製", "zh-CN": "已复制", "en": "Copied", "hi": "कॉपी किया गया", "ja": "コピーしました", "ko": "복사됨" },
    "placeholder": { "zh-TW": "貼上 SQL 查詢...", "zh-CN": "粘贴 SQL 查询...", "en": "Paste SQL query...", "hi": "SQL क्वेरी पेस्ट करें...", "ja": "SQLクエリを貼り付け...", "ko": "SQL 쿼리 붙여넣기..." },
    "outputPlaceholder": { "zh-TW": "格式化後的 SQL 將顯示在這裡", "zh-CN": "格式化后的 SQL 将显示在这里", "en": "Formatted SQL will appear here", "hi": "फॉर्मेट किया गया SQL यहां दिखाई देगा", "ja": "フォーマット後のSQLがここに表示されます", "ko": "포맷된 SQL이 여기에 표시됩니다" },
    "options": { "zh-TW": "選項", "zh-CN": "选项", "en": "Options", "hi": "विकल्प", "ja": "オプション", "ko": "옵션" },
    "indentSize": { "zh-TW": "縮排大小", "zh-CN": "缩进大小", "en": "Indent Size", "hi": "इंडेंट आकार", "ja": "インデントサイズ", "ko": "들여쓰기 크기" },
    "spaces": { "zh-TW": "空格", "zh-CN": "空格", "en": "spaces", "hi": "स्पेस", "ja": "スペース", "ko": "스페이스" },
    "keywordCase": { "zh-TW": "關鍵字大小寫", "zh-CN": "关键字大小写", "en": "Keyword Case", "hi": "कीवर्ड केस", "ja": "キーワードの大文字小文字", "ko": "키워드 대소문자" },
    "uppercase": { "zh-TW": "大寫", "zh-CN": "大写", "en": "UPPERCASE", "hi": "अपरकेस", "ja": "大文字", "ko": "대문자" },
    "lowercase": { "zh-TW": "小寫", "zh-CN": "小写", "en": "lowercase", "hi": "लोअरकेस", "ja": "小文字", "ko": "소문자" },
    "preserve": { "zh-TW": "保持原樣", "zh-CN": "保持原样", "en": "Preserve", "hi": "संरक्षित", "ja": "元のまま", "ko": "유지" },
    "lineBreakBeforeAnd": { "zh-TW": "AND/OR 前換行", "zh-CN": "AND/OR 前换行", "en": "Line break before AND/OR", "hi": "AND/OR से पहले लाइन ब्रेक", "ja": "AND/ORの前で改行", "ko": "AND/OR 앞에서 줄바꿈" },
    "syntaxReference": { "zh-TW": "SQL 語法參考", "zh-CN": "SQL 语法参考", "en": "SQL Syntax Reference", "hi": "SQL सिंटैक्स संदर्भ", "ja": "SQL構文リファレンス", "ko": "SQL 구문 참조" },
    "tab": { "zh-TW": "Tab", "zh-CN": "Tab", "en": "Tab", "hi": "Tab", "ja": "Tab", "ko": "Tab" }
  },

  // 密碼生成器
  "passwordGenerator": {
    "title": {
      "zh-TW": "密碼生成器",
      "zh-CN": "密码生成器",
      "en": "Password Generator",
      "hi": "पासवर्ड जनरेटर",
      "ja": "パスワード生成器",
      "ko": "비밀번호 생성기"
    },
    "description": {
      "zh-TW": "生成安全、隨機的強密碼，支援自訂長度和字符類型",
      "zh-CN": "生成安全、随机的强密码，支持自定义长度和字符类型",
      "en": "Generate secure, random strong passwords with customizable length and character types",
      "hi": "अनुकूलन योग्य लंबाई और वर्ण प्रकारों के साथ सुरक्षित, यादृच्छिक मजबूत पासवर्ड उत्पन्न करें",
      "ja": "カスタマイズ可能な長さと文字タイプで安全でランダムな強力なパスワードを生成",
      "ko": "맞춤 길이와 문자 유형으로 안전하고 무작위의 강력한 비밀번호 생성"
    },
    "generatedPassword": { "zh-TW": "生成的密碼", "zh-CN": "生成的密码", "en": "Generated Password", "hi": "जनरेट किया गया पासवर्ड", "ja": "生成されたパスワード", "ko": "생성된 비밀번호" },
    "copy": { "zh-TW": "複製", "zh-CN": "复制", "en": "Copy", "hi": "कॉपी", "ja": "コピー", "ko": "복사" },
    "copied": { "zh-TW": "已複製", "zh-CN": "已复制", "en": "Copied", "hi": "कॉपी किया गया", "ja": "コピーしました", "ko": "복사됨" },
    "regenerate": { "zh-TW": "重新生成", "zh-CN": "重新生成", "en": "Regenerate", "hi": "पुनर्जनित", "ja": "再生成", "ko": "재생성" },
    "strength": { "zh-TW": "強度", "zh-CN": "强度", "en": "Strength", "hi": "मजबूती", "ja": "強度", "ko": "강도" },
    "weak": { "zh-TW": "弱", "zh-CN": "弱", "en": "Weak", "hi": "कमजोर", "ja": "弱い", "ko": "약함" },
    "fair": { "zh-TW": "一般", "zh-CN": "一般", "en": "Fair", "hi": "ठीक", "ja": "普通", "ko": "보통" },
    "good": { "zh-TW": "良好", "zh-CN": "良好", "en": "Good", "hi": "अच्छा", "ja": "良い", "ko": "좋음" },
    "strong": { "zh-TW": "強", "zh-CN": "强", "en": "Strong", "hi": "मजबूत", "ja": "強い", "ko": "강함" },
    "options": { "zh-TW": "選項", "zh-CN": "选项", "en": "Options", "hi": "विकल्प", "ja": "オプション", "ko": "옵션" },
    "length": { "zh-TW": "長度", "zh-CN": "长度", "en": "Length", "hi": "लंबाई", "ja": "長さ", "ko": "길이" },
    "uppercase": { "zh-TW": "大寫字母", "zh-CN": "大写字母", "en": "Uppercase", "hi": "अपरकेस", "ja": "大文字", "ko": "대문자" },
    "lowercase": { "zh-TW": "小寫字母", "zh-CN": "小写字母", "en": "Lowercase", "hi": "लोअरकेस", "ja": "小文字", "ko": "소문자" },
    "numbers": { "zh-TW": "數字", "zh-CN": "数字", "en": "Numbers", "hi": "संख्याएं", "ja": "数字", "ko": "숫자" },
    "symbols": { "zh-TW": "符號", "zh-CN": "符号", "en": "Symbols", "hi": "प्रतीक", "ja": "記号", "ko": "기호" },
    "excludeSimilar": { "zh-TW": "排除相似字符", "zh-CN": "排除相似字符", "en": "Exclude Similar", "hi": "समान को बाहर करें", "ja": "類似文字を除外", "ko": "유사 문자 제외" },
    "excludeAmbiguous": { "zh-TW": "排除易混淆字符", "zh-CN": "排除易混淆字符", "en": "Exclude Ambiguous", "hi": "अस्पष्ट को बाहर करें", "ja": "曖昧な文字を除外", "ko": "모호한 문자 제외" },
    "bulkGenerate": { "zh-TW": "批量生成", "zh-CN": "批量生成", "en": "Bulk Generate", "hi": "बल्क जनरेट", "ja": "一括生成", "ko": "일괄 생성" },
    "generate": { "zh-TW": "生成", "zh-CN": "生成", "en": "Generate", "hi": "जनरेट", "ja": "生成", "ko": "생성" },
    "securityTips": { "zh-TW": "安全提示", "zh-CN": "安全提示", "en": "Security Tips", "hi": "सुरक्षा सुझाव", "ja": "セキュリティのヒント", "ko": "보안 팁" },
    "tip1": { "zh-TW": "使用至少 12 個字符的密碼", "zh-CN": "使用至少 12 个字符的密码", "en": "Use at least 12 characters", "hi": "कम से कम 12 वर्णों का उपयोग करें", "ja": "少なくとも12文字を使用してください", "ko": "최소 12자 이상 사용" },
    "tip2": { "zh-TW": "混合使用大小寫字母、數字和符號", "zh-CN": "混合使用大小写字母、数字和符号", "en": "Mix uppercase, lowercase, numbers and symbols", "hi": "अपरकेस, लोअरकेस, नंबर और प्रतीकों का मिश्रण", "ja": "大文字、小文字、数字、記号を組み合わせる", "ko": "대문자, 소문자, 숫자, 기호 혼합 사용" },
    "tip3": { "zh-TW": "每個帳戶使用不同的密碼", "zh-CN": "每个账户使用不同的密码", "en": "Use different passwords for each account", "hi": "प्रत्येक खाते के लिए अलग पासवर्ड का उपयोग करें", "ja": "アカウントごとに異なるパスワードを使用", "ko": "각 계정마다 다른 비밀번호 사용" },
    "tip4": { "zh-TW": "考慮使用密碼管理器", "zh-CN": "考虑使用密码管理器", "en": "Consider using a password manager", "hi": "पासवर्ड मैनेजर का उपयोग करने पर विचार करें", "ja": "パスワードマネージャーの使用を検討", "ko": "비밀번호 관리자 사용 고려" }
  },

  // 字數統計器
  "textCounter": {
    "title": {
      "zh-TW": "字數統計器",
      "zh-CN": "字数统计器",
      "en": "Text Counter",
      "hi": "टेक्स्ट काउंटर",
      "ja": "文字数カウンター",
      "ko": "글자수 카운터"
    },
    "description": {
      "zh-TW": "統計文字的字數、字符數、段落數等詳細資訊",
      "zh-CN": "统计文字的字数、字符数、段落数等详细信息",
      "en": "Count words, characters, paragraphs and more detailed text statistics",
      "hi": "शब्द, वर्ण, पैराग्राफ और अधिक विस्तृत टेक्स्ट आंकड़े गिनें",
      "ja": "単語、文字、段落などの詳細なテキスト統計をカウント",
      "ko": "단어, 문자, 단락 등 상세한 텍스트 통계 계산"
    },
    "inputText": { "zh-TW": "輸入文字", "zh-CN": "输入文字", "en": "Input Text", "hi": "इनपुट टेक्स्ट", "ja": "入力テキスト", "ko": "입력 텍스트" },
    "clear": { "zh-TW": "清除", "zh-CN": "清除", "en": "Clear", "hi": "साफ़ करें", "ja": "クリア", "ko": "지우기" },
    "placeholder": { "zh-TW": "在此輸入或貼上文字...", "zh-CN": "在此输入或粘贴文字...", "en": "Enter or paste text here...", "hi": "यहां टेक्स्ट दर्ज या पेस्ट करें...", "ja": "ここにテキストを入力または貼り付け...", "ko": "여기에 텍스트를 입력하거나 붙여넣기..." },
    "characters": { "zh-TW": "字符數", "zh-CN": "字符数", "en": "Characters", "hi": "वर्ण", "ja": "文字数", "ko": "문자수" },
    "charactersNoSpaces": { "zh-TW": "字符數 (不含空格)", "zh-CN": "字符数 (不含空格)", "en": "Characters (no spaces)", "hi": "वर्ण (बिना स्पेस)", "ja": "文字数 (空白なし)", "ko": "문자수 (공백 제외)" },
    "words": { "zh-TW": "單詞數", "zh-CN": "单词数", "en": "Words", "hi": "शब्द", "ja": "単語数", "ko": "단어수" },
    "sentences": { "zh-TW": "句子數", "zh-CN": "句子数", "en": "Sentences", "hi": "वाक्य", "ja": "文の数", "ko": "문장수" },
    "paragraphs": { "zh-TW": "段落數", "zh-CN": "段落数", "en": "Paragraphs", "hi": "पैराग्राफ", "ja": "段落数", "ko": "단락수" },
    "lines": { "zh-TW": "行數", "zh-CN": "行数", "en": "Lines", "hi": "लाइनें", "ja": "行数", "ko": "줄수" },
    "bytes": { "zh-TW": "位元組", "zh-CN": "字节", "en": "Bytes", "hi": "बाइट्स", "ja": "バイト", "ko": "바이트" },
    "readingTime": { "zh-TW": "閱讀時間", "zh-CN": "阅读时间", "en": "Reading Time", "hi": "पढ़ने का समय", "ja": "読書時間", "ko": "읽기 시간" },
    "charDistribution": { "zh-TW": "字符分佈", "zh-CN": "字符分布", "en": "Character Distribution", "hi": "वर्ण वितरण", "ja": "文字分布", "ko": "문자 분포" },
    "letters": { "zh-TW": "字母", "zh-CN": "字母", "en": "Letters", "hi": "अक्षर", "ja": "アルファベット", "ko": "알파벳" },
    "digits": { "zh-TW": "數字", "zh-CN": "数字", "en": "Digits", "hi": "अंक", "ja": "数字", "ko": "숫자" },
    "spaces": { "zh-TW": "空格", "zh-CN": "空格", "en": "Spaces", "hi": "स्पेस", "ja": "空白", "ko": "공백" },
    "punctuation": { "zh-TW": "標點符號", "zh-CN": "标点符号", "en": "Punctuation", "hi": "विराम चिह्न", "ja": "句読点", "ko": "구두점" },
    "other": { "zh-TW": "其他", "zh-CN": "其他", "en": "Other", "hi": "अन्य", "ja": "その他", "ko": "기타" },
    "topWords": { "zh-TW": "高頻詞", "zh-CN": "高频词", "en": "Top Words", "hi": "शीर्ष शब्द", "ja": "頻出単語", "ko": "자주 사용된 단어" },
    "noWords": { "zh-TW": "尚無單詞", "zh-CN": "尚无单词", "en": "No words yet", "hi": "अभी तक कोई शब्द नहीं", "ja": "まだ単語がありません", "ko": "아직 단어가 없습니다" },
    "additionalStats": { "zh-TW": "額外統計", "zh-CN": "额外统计", "en": "Additional Statistics", "hi": "अतिरिक्त आंकड़े", "ja": "追加統計", "ko": "추가 통계" },
    "avgWordLength": { "zh-TW": "平均單詞長度", "zh-CN": "平均单词长度", "en": "Avg Word Length", "hi": "औसत शब्द लंबाई", "ja": "平均単語長", "ko": "평균 단어 길이" },
    "avgSentenceLength": { "zh-TW": "平均句子長度", "zh-CN": "平均句子长度", "en": "Avg Sentence Length", "hi": "औसत वाक्य लंबाई", "ja": "平均文長", "ko": "평균 문장 길이" },
    "longestWord": { "zh-TW": "最長單詞", "zh-CN": "最长单词", "en": "Longest Word", "hi": "सबसे लंबा शब्द", "ja": "最長単語", "ko": "가장 긴 단어" },
    "uniqueWords": { "zh-TW": "獨特單詞", "zh-CN": "独特单词", "en": "Unique Words", "hi": "अद्वितीय शब्द", "ja": "ユニーク単語", "ko": "고유 단어" }
  },

  // 進制轉換器
  "numberBaseConverter": {
    "title": {
      "zh-TW": "進制轉換器",
      "zh-CN": "进制转换器",
      "en": "Number Base Converter",
      "hi": "नंबर बेस कनवर्टर",
      "ja": "基数変換ツール",
      "ko": "진법 변환기"
    },
    "description": {
      "zh-TW": "在二進制、八進制、十進制和十六進制之間轉換數字",
      "zh-CN": "在二进制、八进制、十进制和十六进制之间转换数字",
      "en": "Convert numbers between binary, octal, decimal and hexadecimal",
      "hi": "बाइनरी, ऑक्टल, डेसिमल और हेक्साडेसिमल के बीच संख्याओं को परिवर्तित करें",
      "ja": "2進数、8進数、10進数、16進数間で数値を変換",
      "ko": "2진수, 8진수, 10진수, 16진수 간 숫자 변환"
    },
    "inputBase": { "zh-TW": "輸入進制", "zh-CN": "输入进制", "en": "Input Base", "hi": "इनपुट बेस", "ja": "入力基数", "ko": "입력 진법" },
    "inputValue": { "zh-TW": "輸入值", "zh-CN": "输入值", "en": "Input Value", "hi": "इनपुट मान", "ja": "入力値", "ko": "입력 값" },
    "results": { "zh-TW": "轉換結果", "zh-CN": "转换结果", "en": "Conversion Results", "hi": "रूपांतरण परिणाम", "ja": "変換結果", "ko": "변환 결과" },
    "copy": { "zh-TW": "複製", "zh-CN": "复制", "en": "Copy", "hi": "कॉपी", "ja": "コピー", "ko": "복사" },
    "copied": { "zh-TW": "已複製", "zh-CN": "已复制", "en": "Copied", "hi": "कॉपी किया गया", "ja": "コピーしました", "ko": "복사됨" },
    "invalidInput": { "zh-TW": "無效的輸入值", "zh-CN": "无效的输入值", "en": "Invalid input value", "hi": "अमान्य इनपुट मान", "ja": "無効な入力値", "ko": "잘못된 입력 값" },
    "invalidChars": { "zh-TW": "包含無效字符", "zh-CN": "包含无效字符", "en": "Contains invalid characters", "hi": "अमान्य वर्ण शामिल हैं", "ja": "無効な文字が含まれています", "ko": "잘못된 문자 포함" },
    "conversionError": { "zh-TW": "轉換錯誤", "zh-CN": "转换错误", "en": "Conversion error", "hi": "रूपांतरण त्रुटि", "ja": "変換エラー", "ko": "변환 오류" },
    "additionalFormats": { "zh-TW": "其他格式", "zh-CN": "其他格式", "en": "Additional Formats", "hi": "अतिरिक्त प्रारूप", "ja": "追加フォーマット", "ko": "추가 형식" },
    "ascii": { "zh-TW": "ASCII 字符", "zh-CN": "ASCII 字符", "en": "ASCII Character", "hi": "ASCII वर्ण", "ja": "ASCII文字", "ko": "ASCII 문자" },
    "unicode": { "zh-TW": "Unicode 碼位", "zh-CN": "Unicode 码位", "en": "Unicode Point", "hi": "Unicode पॉइंट", "ja": "Unicodeポイント", "ko": "유니코드 포인트" },
    "roman": { "zh-TW": "羅馬數字", "zh-CN": "罗马数字", "en": "Roman Numeral", "hi": "रोमन अंक", "ja": "ローマ数字", "ko": "로마 숫자" },
    "scientific": { "zh-TW": "科學記號", "zh-CN": "科学记号", "en": "Scientific Notation", "hi": "वैज्ञानिक संकेतन", "ja": "科学的記数法", "ko": "과학적 표기법" },
    "bitOperations": { "zh-TW": "位運算", "zh-CN": "位运算", "en": "Bit Operations", "hi": "बिट ऑपरेशन", "ja": "ビット演算", "ko": "비트 연산" },
    "bitCount": { "zh-TW": "位數 (1)", "zh-CN": "位数 (1)", "en": "Bit Count", "hi": "बिट गणना", "ja": "ビット数", "ko": "비트 수" },
    "reference": { "zh-TW": "進制參考表", "zh-CN": "进制参考表", "en": "Base Reference Table", "hi": "बेस संदर्भ तालिका", "ja": "基数参照表", "ko": "진법 참조 표" },
    "decimal": { "zh-TW": "十進制", "zh-CN": "十进制", "en": "Decimal", "hi": "दशमलव", "ja": "10進数", "ko": "10진수" },
    "binary": { "zh-TW": "二進制", "zh-CN": "二进制", "en": "Binary", "hi": "बाइनरी", "ja": "2進数", "ko": "2진수" },
    "octal": { "zh-TW": "八進制", "zh-CN": "八进制", "en": "Octal", "hi": "ऑक्टल", "ja": "8進数", "ko": "8진수" },
    "hex": { "zh-TW": "十六進制", "zh-CN": "十六进制", "en": "Hexadecimal", "hi": "हेक्साडेसिमल", "ja": "16進数", "ko": "16진수" }
  },

  // JSON → TypeScript 轉換器
  "jsonToTypescript": {
    "title": {
      "zh-TW": "JSON → TypeScript",
      "zh-CN": "JSON → TypeScript",
      "en": "JSON to TypeScript",
      "hi": "JSON से TypeScript",
      "ja": "JSON → TypeScript",
      "ko": "JSON → TypeScript"
    },
    "description": {
      "zh-TW": "將 JSON 資料自動轉換為 TypeScript 介面定義",
      "zh-CN": "将 JSON 数据自动转换为 TypeScript 接口定义",
      "en": "Automatically convert JSON data to TypeScript interface definitions",
      "hi": "JSON डेटा को स्वचालित रूप से TypeScript इंटरफ़ेस परिभाषाओं में परिवर्तित करें",
      "ja": "JSONデータを自動的にTypeScriptインターフェース定義に変換",
      "ko": "JSON 데이터를 자동으로 TypeScript 인터페이스 정의로 변환"
    },
    "loadSample": { "zh-TW": "載入範例", "zh-CN": "加载示例", "en": "Load Sample", "hi": "नमूना लोड करें", "ja": "サンプルを読み込む", "ko": "샘플 로드" },
    "clear": { "zh-TW": "清除", "zh-CN": "清除", "en": "Clear", "hi": "साफ़ करें", "ja": "クリア", "ko": "지우기" },
    "copy": { "zh-TW": "複製", "zh-CN": "复制", "en": "Copy", "hi": "कॉपी", "ja": "コピー", "ko": "복사" },
    "copied": { "zh-TW": "已複製", "zh-CN": "已复制", "en": "Copied", "hi": "कॉपी किया गया", "ja": "コピーしました", "ko": "복사됨" },
    "jsonPlaceholder": { "zh-TW": "貼上 JSON 資料...", "zh-CN": "粘贴 JSON 数据...", "en": "Paste JSON data...", "hi": "JSON डेटा पेस्ट करें...", "ja": "JSONデータを貼り付け...", "ko": "JSON 데이터 붙여넣기..." },
    "tsPlaceholder": { "zh-TW": "TypeScript 介面將顯示在這裡", "zh-CN": "TypeScript 接口将显示在这里", "en": "TypeScript interfaces will appear here", "hi": "TypeScript इंटरफ़ेस यहां दिखाई देंगे", "ja": "TypeScriptインターフェースがここに表示されます", "ko": "TypeScript 인터페이스가 여기에 표시됩니다" },
    "error": { "zh-TW": "錯誤", "zh-CN": "错误", "en": "Error", "hi": "त्रुटि", "ja": "エラー", "ko": "오류" },
    "options": { "zh-TW": "選項", "zh-CN": "选项", "en": "Options", "hi": "विकल्प", "ja": "オプション", "ko": "옵션" },
    "rootName": { "zh-TW": "根類型名稱", "zh-CN": "根类型名称", "en": "Root Type Name", "hi": "रूट टाइप नाम", "ja": "ルート型名", "ko": "루트 타입 이름" },
    "outputType": { "zh-TW": "輸出類型", "zh-CN": "输出类型", "en": "Output Type", "hi": "आउटपुट टाइप", "ja": "出力タイプ", "ko": "출력 타입" },
    "interface": { "zh-TW": "介面 (Interface)", "zh-CN": "接口 (Interface)", "en": "Interface", "hi": "इंटरफ़ेस", "ja": "インターフェース", "ko": "인터페이스" },
    "typeAlias": { "zh-TW": "類型別名 (Type Alias)", "zh-CN": "类型别名 (Type Alias)", "en": "Type Alias", "hi": "टाइप एलियास", "ja": "型エイリアス", "ko": "타입 별칭" },
    "addExport": { "zh-TW": "添加 export", "zh-CN": "添加 export", "en": "Add export", "hi": "export जोड़ें", "ja": "exportを追加", "ko": "export 추가" },
    "optionalProperties": { "zh-TW": "所有屬性可選", "zh-CN": "所有属性可选", "en": "Optional Properties", "hi": "वैकल्पिक प्रॉपर्टीज", "ja": "すべてのプロパティをオプションに", "ko": "모든 속성 선택적" },
    "addReadonly": { "zh-TW": "添加 readonly", "zh-CN": "添加 readonly", "en": "Add readonly", "hi": "readonly जोड़ें", "ja": "readonlyを追加", "ko": "readonly 추가" },
    "featuresTitle": { "zh-TW": "功能特色", "zh-CN": "功能特色", "en": "Features", "hi": "विशेषताएं", "ja": "機能", "ko": "기능" },
    "feature1": { "zh-TW": "自動推斷屬性類型", "zh-CN": "自动推断属性类型", "en": "Automatic type inference", "hi": "स्वचालित टाइप अनुमान", "ja": "自動型推論", "ko": "자동 타입 추론" },
    "feature2": { "zh-TW": "支援巢狀物件和陣列", "zh-CN": "支持嵌套对象和数组", "en": "Supports nested objects and arrays", "hi": "नेस्टेड ऑब्जेक्ट और एरे का समर्थन", "ja": "ネストされたオブジェクトと配列をサポート", "ko": "중첩 객체 및 배열 지원" },
    "feature3": { "zh-TW": "可自訂輸出格式", "zh-CN": "可自定义输出格式", "en": "Customizable output format", "hi": "अनुकूलन योग्य आउटपुट प्रारूप", "ja": "カスタマイズ可能な出力形式", "ko": "맞춤 출력 형식" },
    "feature4": { "zh-TW": "自動命名介面", "zh-CN": "自动命名接口", "en": "Automatic interface naming", "hi": "स्वचालित इंटरफ़ेस नामकरण", "ja": "自動インターフェース命名", "ko": "자동 인터페이스 이름 지정" }
  },

  // JSON Path 查詢器
  "jsonPathQuery": {
    "title": {
      "zh-TW": "JSON Path 查詢器",
      "zh-CN": "JSON Path 查询器",
      "en": "JSON Path Query",
      "hi": "JSON Path क्वेरी",
      "ja": "JSON Path クエリ",
      "ko": "JSON Path 쿼리"
    },
    "description": {
      "zh-TW": "使用 JSONPath 語法查詢和過濾 JSON 資料",
      "zh-CN": "使用 JSONPath 语法查询和过滤 JSON 数据",
      "en": "Query and filter JSON data using JSONPath syntax",
      "hi": "JSONPath सिंटैक्स का उपयोग करके JSON डेटा क्वेरी और फ़िल्टर करें",
      "ja": "JSONPath構文を使用してJSONデータをクエリ・フィルタリング",
      "ko": "JSONPath 구문을 사용하여 JSON 데이터 쿼리 및 필터링"
    },
    "query": { "zh-TW": "JSONPath 查詢", "zh-CN": "JSONPath 查询", "en": "JSONPath Query", "hi": "JSONPath क्वेरी", "ja": "JSONPathクエリ", "ko": "JSONPath 쿼리" },
    "queryPlaceholder": { "zh-TW": "輸入 JSONPath 表達式 (例: $.store.products[*].name)", "zh-CN": "输入 JSONPath 表达式 (例: $.store.products[*].name)", "en": "Enter JSONPath expression (e.g., $.store.products[*].name)", "hi": "JSONPath अभिव्यक्ति दर्ज करें", "ja": "JSONPath式を入力 (例: $.store.products[*].name)", "ko": "JSONPath 표현식 입력 (예: $.store.products[*].name)" },
    "execute": { "zh-TW": "執行", "zh-CN": "执行", "en": "Execute", "hi": "निष्पादित", "ja": "実行", "ko": "실행" },
    "examples": { "zh-TW": "快速範例", "zh-CN": "快速示例", "en": "Quick examples", "hi": "त्वरित उदाहरण", "ja": "クイック例", "ko": "빠른 예제" },
    "loadSample": { "zh-TW": "載入範例", "zh-CN": "加载示例", "en": "Load Sample", "hi": "नमूना लोड करें", "ja": "サンプルを読み込む", "ko": "샘플 로드" },
    "format": { "zh-TW": "格式化", "zh-CN": "格式化", "en": "Format", "hi": "फॉर्मेट", "ja": "フォーマット", "ko": "포맷" },
    "jsonPlaceholder": { "zh-TW": "貼上 JSON 資料...", "zh-CN": "粘贴 JSON 数据...", "en": "Paste JSON data...", "hi": "JSON डेटा पेस्ट करें...", "ja": "JSONデータを貼り付け...", "ko": "JSON 데이터 붙여넣기..." },
    "result": { "zh-TW": "查詢結果", "zh-CN": "查询结果", "en": "Query Result", "hi": "क्वेरी परिणाम", "ja": "クエリ結果", "ko": "쿼리 결과" },
    "matches": { "zh-TW": "個匹配", "zh-CN": "个匹配", "en": "matches", "hi": "मैच", "ja": "件のマッチ", "ko": "개 일치" },
    "copy": { "zh-TW": "複製", "zh-CN": "复制", "en": "Copy", "hi": "कॉपी", "ja": "コピー", "ko": "복사" },
    "copied": { "zh-TW": "已複製", "zh-CN": "已复制", "en": "Copied", "hi": "कॉपी किया गया", "ja": "コピーしました", "ko": "복사됨" },
    "resultPlaceholder": { "zh-TW": "查詢結果將顯示在這裡", "zh-CN": "查询结果将显示在这里", "en": "Query results will appear here", "hi": "क्वेरी परिणाम यहां दिखाई देंगे", "ja": "クエリ結果がここに表示されます", "ko": "쿼리 결과가 여기에 표시됩니다" },
    "error": { "zh-TW": "錯誤", "zh-CN": "错误", "en": "Error", "hi": "त्रुटि", "ja": "エラー", "ko": "오류" },
    "syntaxReference": { "zh-TW": "JSONPath 語法參考", "zh-CN": "JSONPath 语法参考", "en": "JSONPath Syntax Reference", "hi": "JSONPath सिंटैक्स संदर्भ", "ja": "JSONPath構文リファレンス", "ko": "JSONPath 구문 참조" },
    "syntax": { "zh-TW": "語法", "zh-CN": "语法", "en": "Syntax", "hi": "सिंटैक्स", "ja": "構文", "ko": "구문" },
    "syntaxDesc": { "zh-TW": "說明", "zh-CN": "说明", "en": "Description", "hi": "विवरण", "ja": "説明", "ko": "설명" },
    "example": { "zh-TW": "範例", "zh-CN": "示例", "en": "Example", "hi": "उदाहरण", "ja": "例", "ko": "예제" },
    "rootObject": { "zh-TW": "根物件", "zh-CN": "根对象", "en": "Root object", "hi": "रूट ऑब्जेक्ट", "ja": "ルートオブジェクト", "ko": "루트 객체" },
    "childProperty": { "zh-TW": "子屬性", "zh-CN": "子属性", "en": "Child property", "hi": "चाइल्ड प्रॉपर्टी", "ja": "子プロパティ", "ko": "하위 속성" },
    "arrayIndex": { "zh-TW": "陣列索引", "zh-CN": "数组索引", "en": "Array index", "hi": "एरे इंडेक्स", "ja": "配列インデックス", "ko": "배열 인덱스" },
    "allElements": { "zh-TW": "所有元素", "zh-CN": "所有元素", "en": "All elements", "hi": "सभी तत्व", "ja": "すべての要素", "ko": "모든 요소" },
    "recursive": { "zh-TW": "遞迴搜尋", "zh-CN": "递归搜索", "en": "Recursive search", "hi": "पुनरावर्ती खोज", "ja": "再帰検索", "ko": "재귀 검색" },
    "slice": { "zh-TW": "陣列切片", "zh-CN": "数组切片", "en": "Array slice", "hi": "एरे स्लाइस", "ja": "配列スライス", "ko": "배열 슬라이스" }
  },

  // 工具評分/評論
  "rating": {
    "title": { "zh-TW": "使用者評價", "zh-CN": "用户评价", "en": "User Ratings", "hi": "उपयोगकर्ता रेटिंग", "ja": "ユーザー評価", "ko": "사용자 평가" },
    "reviews": { "zh-TW": "則評論", "zh-CN": "条评论", "en": "reviews", "hi": "समीक्षाएं", "ja": "件のレビュー", "ko": "개 리뷰" },
    "rateThis": { "zh-TW": "為此工具評分", "zh-CN": "为此工具评分", "en": "Rate this tool", "hi": "इस टूल को रेट करें", "ja": "このツールを評価", "ko": "이 도구 평가" },
    "thanksForRating": { "zh-TW": "感謝您的評分！", "zh-CN": "感谢您的评分！", "en": "Thanks for rating!", "hi": "रेटिंग के लिए धन्यवाद!", "ja": "評価ありがとうございます！", "ko": "평가해 주셔서 감사합니다!" },
    "comments": { "zh-TW": "評論", "zh-CN": "评论", "en": "Comments", "hi": "टिप्पणियां", "ja": "コメント", "ko": "댓글" },
    "writeComment": { "zh-TW": "撰寫評論", "zh-CN": "撰写评论", "en": "Write a Comment", "hi": "टिप्पणी लिखें", "ja": "コメントを書く", "ko": "댓글 작성" },
    "namePlaceholder": { "zh-TW": "您的名稱（選填）", "zh-CN": "您的名称（选填）", "en": "Your name (optional)", "hi": "आपका नाम (वैकल्पिक)", "ja": "お名前（任意）", "ko": "이름 (선택사항)" },
    "commentPlaceholder": { "zh-TW": "分享您的使用心得...", "zh-CN": "分享您的使用心得...", "en": "Share your experience...", "hi": "अपना अनुभव साझा करें...", "ja": "ご感想をお聞かせください...", "ko": "사용 경험을 공유하세요..." },
    "yourRating": { "zh-TW": "您的評分", "zh-CN": "您的评分", "en": "Your Rating", "hi": "आपकी रेटिंग", "ja": "あなたの評価", "ko": "평가" },
    "cancel": { "zh-TW": "取消", "zh-CN": "取消", "en": "Cancel", "hi": "रद्द करें", "ja": "キャンセル", "ko": "취소" },
    "submit": { "zh-TW": "提交", "zh-CN": "提交", "en": "Submit", "hi": "सबमिट", "ja": "送信", "ko": "제출" },
    "loadMore": { "zh-TW": "載入更多", "zh-CN": "加载更多", "en": "Load More", "hi": "और लोड करें", "ja": "もっと読み込む", "ko": "더 보기" },
    "more": { "zh-TW": "則更多", "zh-CN": "条更多", "en": "more", "hi": "और", "ja": "件以上", "ko": "개 더" },
    "noComments": { "zh-TW": "尚無評論", "zh-CN": "尚无评论", "en": "No comments yet", "hi": "अभी तक कोई टिप्पणी नहीं", "ja": "まだコメントがありません", "ko": "아직 댓글이 없습니다" },
    "beFirst": { "zh-TW": "成為第一個評論的人！", "zh-CN": "成为第一个评论的人！", "en": "Be the first to comment!", "hi": "पहले टिप्पणी करने वाले बनें!", "ja": "最初のコメントを投稿してください！", "ko": "첫 번째 댓글을 남겨주세요!" }
  }
}
